import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Tab,
  Nav,
  Form,
  Modal,
  Accordion,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import Swal from 'sweetalert2';
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { firestore as db } from "../../config/Config";
import { useLocation } from "react-router-dom";
import { Collapse } from "bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchKitchenList } from "../../redux/kitchenReducer";
import { useNavigate } from "react-router-dom";
import { auth } from "../../config/Config";
import { createRooms } from "../../redux/addRoomReducer";
import Sidebar from "../SidebarNav";
import { InputLabel, NativeSelect } from "@mui/material";


export default function AssignAddRoom({ clientDataFor }) {

  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;

  console.log("clients data", data);

  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);

  // useEffect(() => {
  //   dispatch(fetchKitchenList());
  // }, []);

  // const { looseThingsData } = useSelector(
  //   (state) => state.looseThings
  // );

  // console.log("sdfsdf", kitchenThingsData);


  // Room Type 

  const [roomType, setRoomType] = useState(data['roomType']);
  // console.log("roomType", roomType);

  const [roomTypeName, setRoomTypeName] = useState(data['roomName']);
  // console.log("roomTypeName", roomTypeName);
  const [roomTypeDesign, setRoomTypeDesign] = useState("");
  const [roomTypeDescription, setRoomTypeDescription] = useState("");
  const [roomTypeModal, setRoomTypeModal] = useState('');
  // console.log('popop',roomTypeModal);

  const [roomTypePrice, setRoomTypePrice] = useState(0);
  // console.log("roomTypePrice", roomTypePrice);
  const [roomTypeWoodPrice, setRoomTypeWoodPrice] = useState(0);
  // console.log("roomTypeWoodPrice", roomTypeWoodPrice);
  // const [priceGen, setPriceGen] = useState("value");
  // console.log("priceGen", priceGen);




  const [defkey, setDefkey] = useState('room');

  const handleRoomTypeCancel = () => {
    setRoomType("");
    setRoomTypeName("");
    setRoomTypeDesign("");
    setRoomTypeDescription("");
      navigation("/assigned/view-rooms", { state: data });
  }

  const handleRoomTypeSubmit = (e) => {
    e.preventDefault();
    const roomData = [{ 'roomType': roomType }, { 'roomTypeName': roomTypeName }, { 'roomTypeDesign': roomTypeDesign }, { 'roomTypeDescription': roomTypeDescription }];
    localStorage.setItem("roomTypeData", JSON.stringify(roomData));

  }

  // Base cabinet modal things & all

  const [addShow, setAddShow] = useState(false);
  const [roomData, setRoomData] = useState([]);


  // Material things

  const [kitchenBaseGrandTotal, setKitchenBaseGrandTotal] = useState(0);

  const [materialType, setMaterialType] = useState("");
  const [materialLabel, setMaterialLabel] = useState(0);
  const [materialValue, setMaterialValue] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [modalUrl, setModalUrl] = useState("");
  const [materialWidth, setMaterialWidth] = useState(0);
  const [materialHeight, setMaterialHeight] = useState(0);
  // const [materialDepth, setMaterialDepth] = useState(2);
  const [materialQuantity, setMaterialQuantity] = useState(0);
  const [materialPrice, setMaterialPrice] = useState(0);
  const handleFistItem = (name) => {
    setModalTitle(name.label);
    setModalUrl(name.url);
  };
  const handleCalculation = (e) => {
    setMaterialPrice(
      materialType * materialWidth * materialHeight * materialQuantity
    );
  };




  const handleLogOut = () => {
    auth.signOut();
    // navigation('/login');
  }

  // writting code for dynamic fields of inputs

  const [selectedItems, setSelectedItems] = useState([]);

  const handleQuantityChange = (itemId, newQuantity) => {
    const updatedItems = selectedItems.map((item) => {
      if (item.id === itemId) {
        return {
          ...item,
          selectedQuantity: newQuantity,
        };
      }
      return item;
    });

    setSelectedItems(updatedItems);
  };



  // Save Room types and naem

  const handleSaveNameType = () => {
    // alert('everything');

    // const roomDatas = {

    //   title: '',
    //   fields: '',
    //   roomType: roomType,
    //   roomTypeName: roomTypeName,
    //   roomTypeDesign: roomTypeDesign,
    //   roomTypeDescription: roomTypeDescription,
    //   roomTypePrice: 0,
    //   roomTypeWoodPrice: 0,
    //   id: data.ID,
    // };


    // dispatch(createRooms(roomDatas));
    // navigation("/projects/view-rooms", { state: data });
    const url = `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: '',
        fields: '',
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: 0,
        priceMode: priceGen,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
        navigation("/assigned/view-rooms", { state: data });
        
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  // Save Everything Calculation & Headings

  const handleSaveEverything = () => {
    // alert('everything');

    const roomDatas = {

      // title : [{'accordin' : [modalTitle, modalUrl, kitchenBaseGrandTotal]},{'material' : [materialType, materialWidth, materialHeight, materialQuantity, materialPrice]},{'baseHandleType' : [accessoriesBaseHandleType, accessoriesBaseHandleQuantity, accessoriesBaseHandlePrice]},{'thaliBasket' : [accessoriesThaliBasketType, accessoriesThaliBasketQuantity, accessoriesThaliBasketPrice]},{'thaliInlet' : [accessoriesThaliInletType, accessoriesThaliInletQuantity, accessoriesThaliInletPrice]},{'dustbinBasic' : [accessoriesDustbinBasicType, accessoriesDustbinBasicQuantity, accessoriesDustbinBasicPrice]},{'wickerBasket' : [accessoriesWickerBasketBasicType, accessoriesWickerBasketBasicQuantity, accessoriesWickerBasketBasicPrice]},{'detergentHolder' : [accessoriesDetergentHolderBasicType, accessoriesDetergentHolderBasicQuantity, accessoriesDetergentHolderBasicPrice]}],
      title: roomData,
      roomType: roomType,
      roomTypeName: roomTypeName,
      roomTypeDesign: roomTypeDesign,
      roomTypeDescription: roomTypeDescription,
      roomTypePrice: kitchenBaseGrandTotal,
      id: data.ID,
    };


    dispatch(createRooms(roomDatas));
    navigation("/projects/view-rooms", { state: data });
  }

  // dynamic form fields and data

  const [dynamicData, setDynamicData] = useState([{ fname: "", lname: "" }]);

  const handleAddClick = () => {
    setDynamicData([...dynamicData, { fname: "", lname: "" }])
  }

  const handleAddChange = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...dynamicData];
    onchangeVal[i][name] = value;
    setDynamicData(onchangeVal);
  }






  // dynamic for kitchen furniture
  const { kitchenThingsData } = useSelector((state) => state.kitchenThings);
  // console.log("kitchenThingsData", kitchenThingsData);


  // dynamic for extra items in every room
  const [extraItemMeasure, setExtraItemMeasure] = useState('');
  const [extraItemName, setExtraItemName] = useState('');
  const [extraItemMaterialName, setExtraItemMaterialName] = useState('');
  const [extraItemMaterialValue, setExtraItemMaterialValue] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [extraItemType, setExtraItemType] = useState('');

  const [kitchenThingsDataCopy, setKitchenThingsDataCopy] = useState([...kitchenThingsData]);
  console.log("kitchenFormData 1", kitchenThingsDataCopy);


  const [kitchenFormData, setKitchenFormData] = useState(
    kitchenThingsDataCopy.map((item) => ({

      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      price: 0,
      remark: "",
      type: item.type,
    }))
  );

  // console.log("kitchenFormData", kitchenFormData);
  const handleCheckboxChange = (event) => {
    // console.log("ppp", event);

    setIsChecked(event.target.checked);
    // console.log("ppp", event.target.checked);
    setExtraItemType(event.target.checked ? 'woodwork' : '');
  };

  // Function to add a new kitchen item
  const addNewKitchenItem = () => {
    const newKitchenItem = {
      name: extraItemName,
      measurement: extraItemMeasure,
      material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
      type: extraItemType,
      isUserAdded: true,
    };

    setKitchenThingsDataCopy((prevData) => {
      const updatedData = [...prevData, newKitchenItem];
      return updatedData;
    });

    setKitchenFormData((prevData) => [
      ...prevData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);

    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
  };

  // Function to handle changes to the kitchen form fields
  const handleKitchenChange = (e, index, field) => {
    const newValue =parseFloat(e.target.value)||0;
    const updatedKitchenFormData = [...kitchenFormData];
    const item = { ...updatedKitchenFormData[index] };
    console.log("eee", newValue);

    const incrementPercentage = data['increment'] / 100;

    // Update the price based on the measurement type
    if (kitchenThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * newValue * (1 + incrementPercentage))
        : Math.round(item.value * newValue);
    } else if (kitchenThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage))
        : Math.round(item.value * item.width * item.height * item.qnty);
    } else if (kitchenThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * newValue * (1 + incrementPercentage))
        : Math.round(item.value * newValue);
    } else if (kitchenThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * item.height * item.width * (1 + incrementPercentage))
        : Math.round(item.value * item.height * item.width);
    } else if (kitchenThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * newValue * (1 + incrementPercentage))
        : Math.round(item.value * newValue);
    }

    // Update state
    updatedKitchenFormData[index] = item;

    setKitchenFormData(updatedKitchenFormData);
  };

  // Function to handle price change
  const handleKitchenPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    const updatedKitchenFormData = [...kitchenFormData];
    const item = { ...updatedKitchenFormData[index] };
    item[field] = newValue;

    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
  };

  // Function to handle remark change
  const handleKitchenRemarkChange = (e, index, field) => {
    const newValue = e.target.value;
    const updatedKitchenFormData = [...kitchenFormData];
    const item = { ...updatedKitchenFormData[index] };
    item[field] = newValue;

    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
  };

  // Function to handle option change
  const handleKitchenOptionChange = (e, index) => {
    const value = e.target.value || 0;
    console.log("eee", value);

    const selectedLabel = e.target.label;
    // console.log("selectedLabel", selectedLabel);
    const incrementPercentage = data['increment'] / 100;
    // console.log("pppppp", incrementPercentage);

    setKitchenFormData((prevData) => {
      const newData = [...prevData];
      const item = { ...newData[index] };
      item.value = value;
      item.valueIncresed = Math.round(value * (1 + incrementPercentage));
      item.label = selectedLabel;
      // console.log("pppppp", value);
      // console.log("pppppp", item.value);
      // console.log("pppppp", item.valueIncresed);
      if (kitchenThingsDataCopy[index].measurement === "area") {
        item.price = item.type === "woodwork"
          ? Math.round(value * item.area * (1 + incrementPercentage))
          : Math.round(value * item.area);
      } else if (kitchenThingsDataCopy[index].measurement === "width") {
        item.price = item.type === "woodwork"
          ? Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage))
          : Math.round(value * item.width * item.height * item.qnty);
      } else if (kitchenThingsDataCopy[index].measurement === "qty") {
        item.price = item.type === "woodwork"
          ? Math.round(value * item.qnty * (1 + incrementPercentage))
          : Math.round(value * item.qnty);
      } else if (kitchenThingsDataCopy[index].measurement === "length") {
        item.price = item.type === "woodwork"
          ? Math.round(value * item.height * item.width * (1 + incrementPercentage))
          : Math.round(value * item.height * item.width);
      } else if (kitchenThingsDataCopy[index].measurement === "rft") {
        item.price = item.type === "woodwork"
          ? Math.round(value * item.rft * (1 + incrementPercentage))
          : Math.round(value * item.rft);
      }

      newData[index] = item;
      return newData;
    });
  };

  // Recalculate total prices whenever kitchenFormData changes
  useEffect(() => {
    // Calculate total price safely, ensuring item.price is a valid number
    const totalPrice = kitchenFormData.reduce((total, item) => {
      const price = parseFloat(item.price) || 0;  // Ensure valid number
      return total + price;
    }, 0);
    setRoomTypePrice(totalPrice);

    // Calculate total woodwork price safely
    const totalWoodworkPrice = kitchenFormData.reduce((total, item) => {
      if (item.type === 'woodwork') {
        const price = parseFloat(item.price) || 0;  // Ensure valid number
        return total + price;
      }
      return total;
    }, 0);
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [kitchenFormData]);  // Depend on kitchenFormData


  // Function to save kitchen data
  const saveKitchenData = async () => {

    // Recalculate prices
    const updatedKitchenFormData = kitchenFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });
    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);

    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

    const url =`https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: kitchenFormData,
          title2: materialFields,
          fields: kitchenThingsDataCopy,
          roomType: roomType,
          roomTypeName: roomTypeName,
          roomTypeDesign: roomTypeDesign,
          roomTypeDescription: roomTypeDescription,
          roomTypePrice: newRoomTypePrice,
          roomTypeWoodPrice: newRoomTypeWoodPrice,
          priceMode: priceGen,
          roomTypePrice2: materialFieldsTotal,
          userId: data.ID,
        }),
      });

      if (response.ok) {
        setRoomTypeWoodPrice(0);
        
          navigation("/assigned/view-rooms", { state: data });
        }
        
    } catch (error) {
      console.error('Error:', error);
    }
  };


  const deleteUserAddedKitchenItem = (index) => {
    // Only delete if the item is user-added
    if (kitchenThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...kitchenThingsDataCopy];
      const updatedKitchenFormData = [...kitchenFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setKitchenThingsDataCopy(updatedKitchenThingsDataCopy);
      setKitchenFormData(updatedKitchenFormData);
    }
  };




  // dynamic for Bedroom furniture 



  const { bedroomThingsData } = useSelector(
    (state) => state.bedroomThings
  );

  const [bedroomThingsDataCopy, setBedroomThingsDataCopy] = useState(bedroomThingsData);
  console.log("bedroomFormData 2", bedroomThingsDataCopy);
  console.log("bedroomFormData 1", bedroomThingsData);



  const [bedroomFormData, setBedroomFormData] = useState(
    bedroomThingsDataCopy.map((item) => ({
      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      label2: "",
      value2: 0,
      valueIncresed2: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      price: 0,
      remark: "",
      type: item.type,
    }))
  );
  // console.log("bedroomFormData", bedroomFormData);
  const OriginalPriceType = data.priceType

  // Update bedroomFormData when OriginalPriceType changes
  const addNewBedroomItem = () => {

    setBedroomThingsDataCopy([
      ...bedroomThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data", bedroomThingsDataCopy);
    setBedroomFormData([
      ...bedroomFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        label2: "",
        value2: 0,
        valueIncresed2: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };


  const handleBedroomChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    console.log("eee",newValue);
    // console.log('pppp',newValue);

    // const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];


    const incrementPercentage = data['increment'] / 100;

    if (bedroomThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue) || 0;
      }
    } else if (bedroomThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "door") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
      }
    }


    //roomTypePrice
    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };


  // const handleBedroomPriceChange = (e, index, field) => {
  //   const newValue = parseFloat(e.target.value);
  //   // const newValue = e.target.value;
  //   const updatedBedroomFormData = [...bedroomFormData];
  //   const item = updatedBedroomFormData[index];


  //   item[field] = newValue;

  //   // Update the state with the modified data
  //   updatedBedroomFormData[index] = item;
  //   setBedroomFormData(updatedBedroomFormData);
  //   // console.log("price checking", bedroomFormData);
  // };


  const handleBedroomRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];


    item[field] = newValue;

    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };



  const handleBedroomOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label;
    const incrementPercentage = data['increment'] / 100;
    console.log("eee",value);
    

    // console.log("incrementPercentage",value);


    setBedroomFormData((prevData) => {
      const newData = [...prevData]; newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));

      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (bedroomThingsDataCopy[index].measurement === "area") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "width") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "qty") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "length") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "rft") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "door") {
        if (item.type === "woodwork") {
          item.price = Math.round(((value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(((value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
        }
      }


      return newData;
    });
  };


  const handleBedroomOption2Change = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const incrementPercentage = data['increment'] / 100;

    setBedroomFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value2'] = value;
      newData[index]['valueIncresed2'] = Math.round(value * (1 + incrementPercentage));

      newData[index]['label2'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (bedroomThingsDataCopy[index].measurement === "door") {
        // Parse value as a floating-point number (assuming it's a decimal number)
        const valueAsNumber = parseFloat(value);
        if (!isNaN(valueAsNumber)) {
          item.price = Math.round(((item.value * item.width * item.height * item.qnty) + valueAsNumber) * (1 + incrementPercentage));
        }
      }


      return newData;
    });
  };

  // const calculateBedroomTotal = () => {
  //   let newTotal = 0;
  //   for (let i = 0; i < bedroomFormData.length; i++) {
  //     newTotal += parseInt(bedroomFormData[i].price);
  //   }
  //   return newTotal;
  // };

  // useEffect(() => {
  //   const newBedroomTotal = calculateBedroomTotal();

  //   setRoomTypePrice(newBedroomTotal);
  // }, [bedroomFormData]); // This will update the total whenever formData changes.

  // to calculate Total Price
  useEffect(() => {
    // Calculate total price
    const totalPrice = bedroomFormData.reduce((total, item) => {
      return total + (parseFloat(item.price) || 0);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
    // console.log(roomTypePrice);

  }, [bedroomFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = bedroomFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [bedroomFormData]);


  const calculateTotalPricesBeforeSave = () => {
    // Calculate total price safely
    const totalPrice = bedroomFormData.reduce((total, item) => {
      const price = parseFloat(item.price) || 0; // Ensure price is a valid number
      return total + price;
    }, 0);

    setRoomTypePrice(totalPrice);

    // Calculate total woodwork price safely
    const totalWoodworkPrice = bedroomFormData.reduce((total, item) => {
      const price = parseFloat(item.price) || 0; // Ensure price is valid
      if (item.type === "woodwork") {
        return total + price;
      }
      return total;
    }, 0);

    setRoomTypeWoodPrice(totalWoodworkPrice);

    saveBedroomData();
  };

  // // Trigger save once total prices are calculated
  // useEffect(() => {
  //   if (roomTypePrice > 0 || roomTypeWoodPrice > 0) {
  //     saveBedroomData();
  //   }
  // }, [roomTypePrice, roomTypeWoodPrice]);

  const saveBedroomData = async () => {


    const incrementPercentage = data['increment'] / 100;

    // Recalculate prices
    const updatedBedroomFormData = bedroomFormData.map((item, index) => {
      let newPrice = 0;

      if (bedroomThingsDataCopy[index].measurement === "area") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.area);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "width") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "qty") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "length") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.height * item.width);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "rft") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.rft);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "door") {
        if (item.type === "woodwork") {
          newPrice = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedBedroomFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedBedroomFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);
    // if(!newRoomTypePrice){
    //   alert("Error in price type");
    // }
    // if(!newRoomTypeWoodPrice){
    //   alert("Error in Wood price type");
    // }

    const url = `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: bedroomFormData,
        fields: bedroomThingsDataCopy,
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        priceMode: priceGen,
        roomTypeWoodPrice: newRoomTypeWoodPrice,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
       
        navigation("/assigned/view-rooms", { state: data });
        
      }
      )
      .catch((error) => console.error('Error:', error));
  }


  const deleteUserAddedBedroomItem = (index) => {
    // Only delete if the item is user-added
    if (bedroomThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...bedroomThingsDataCopy];
      const updatedKitchenFormData = [...bedroomFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setBedroomThingsDataCopy(updatedKitchenThingsDataCopy);
      setBedroomFormData(updatedKitchenFormData);
    }
  };

  // dynamic for foyer furniture 

  const { foyerThingsData } = useSelector(
    (state) => state.foyerThings
  );

  const [foyerThingsDataCopy, setFoyerThingsDataCopy] = useState(foyerThingsData);
  // console.log("foyerThingsDataCopy", foyerThingsDataCopy);

  const [foyerFormData, setFoyerFormData] = useState(
    foyerThingsDataCopy.map((item) => ({
      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      price: 0,
      remark: "",
      type: item.type,
    }))
  );
  // console.log("foyerFormData", foyerFormData);

  const addNewFoyerItem = () => {

    setFoyerThingsDataCopy([
      ...foyerThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setFoyerFormData([
      ...foyerFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };



  const handleFoyerChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) ||0;
    // const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];
    const incrementPercentage = data['increment'] / 100;

    if (foyerThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (foyerThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (foyerThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (foyerThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (foyerThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    }

    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };


  const handleFoyerPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };




  const handleFoyerRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };



  const handleFoyerOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label;
    const incrementPercentage = data['increment'] / 100;

    setFoyerFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (foyerThingsDataCopy[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (foyerThingsDataCopy[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (foyerThingsDataCopy[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (foyerThingsDataCopy[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (foyerThingsDataCopy[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      }

      return newData;
    });
  };




  // const calculateFoyerTotal = () => {
  //   let newTotal = 0;
  //   for (let i = 0; i < foyerFormData.length; i++) {
  //     newTotal += parseInt(foyerFormData[i].price);
  //   }
  //   return newTotal;
  // };

  // useEffect(() => {
  //   const newFoyerTotal = calculateFoyerTotal();

  //   setRoomTypePrice(newFoyerTotal);
  // }, [foyerFormData]); // This will update the total whenever formData changes.

  useEffect(() => {
    // Calculate total price
    const totalPrice = foyerFormData.reduce((total, item) => {
      return total + (parseInt(item.price) || 0);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [foyerFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = foyerFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [foyerFormData]);



  const saveFoyerData = async () => {



    // Recalculate prices
    const updatedKitchenFormData = foyerFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

    const url =`https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`;




    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: foyerFormData,
        fields: foyerThingsDataCopy,
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        priceMode: priceGen,
        roomTypeWoodPrice: newRoomTypeWoodPrice,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
          navigation("/assigned/view-rooms", { state: data });
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  const deleteUserAddedFoyerItem = (index) => {
    // Only delete if the item is user-added
    if (foyerThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...foyerThingsDataCopy];
      const updatedKitchenFormData = [...foyerFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setFoyerThingsDataCopy(updatedKitchenThingsDataCopy);
      setFoyerFormData(updatedKitchenFormData);
    }
  };


  // dynamic for living furniture 

  const { livingThingsData } = useSelector(
    (state) => state.livingThings
  );


  const [livingThingsDataCopy, setLivingThingsDataCopy] = useState(livingThingsData);
  // console.log("livingThingsDataCopy", livingThingsDataCopy);


  const [livingFormData, setLivingFormData] = useState(
    livingThingsDataCopy.map((item) => ({
      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      price: 0,
      remark: "",
      type: item.type,
    }))
  );

  const addNewLivingItem = () => {

    setLivingThingsDataCopy([
      ...livingThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setLivingFormData([
      ...livingFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };




  const handleLivingChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value)||0;
    // const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];
    const incrementPercentage = data['increment'] / 100;

    if (livingThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (livingThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (livingThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (livingThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (livingThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    }

    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };


  const handleLivingPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };




  const handleLivingRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };



  const handleLivingOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label;
    const incrementPercentage = data['increment'] / 100;

    setLivingFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (livingThingsDataCopy[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (livingThingsDataCopy[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (livingThingsDataCopy[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (livingThingsDataCopy[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (livingThingsDataCopy[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      }

      return newData;
    });
  };




  // const calculateLivingTotal = () => {
  //   let newTotal = 0;
  //   for (let i = 0; i < livingFormData.length; i++) {
  //     newTotal += parseInt(livingFormData[i].price);
  //   }
  //   return newTotal;
  // };

  // useEffect(() => {
  //   const newlivingTotal = calculateLivingTotal();

  //   setRoomTypePrice(newlivingTotal);
  // }, [livingFormData]); // This will update the total whenever formData changes.


  useEffect(() => {
    // Calculate total price
    const totalPrice = livingFormData.reduce((total, item) => {
      return total + (parseInt(item.price) || 0);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [livingFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = livingFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [livingFormData]);


  const saveLivingData = async () => {


    // Recalculate prices
    const updatedKitchenFormData = livingFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);
    const url = `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: livingFormData,
        fields: livingThingsDataCopy,
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        priceMode: priceGen,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: newRoomTypeWoodPrice,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
   
          navigation("/assigned/view-rooms", { state: data });
   
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  const deleteUserAddedLivingItem = (index) => {
    // Only delete if the item is user-added
    if (livingThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...livingThingsDataCopy];
      const updatedKitchenFormData = [...livingFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setLivingThingsDataCopy(updatedKitchenThingsDataCopy);
      setLivingFormData(updatedKitchenFormData);
    }
  };

  // dynamic for other furniture 

  const { otherWorkThingsData } = useSelector(
    (state) => state.OtherWorkThings
  );

  const [otherThings , setOtherThings]= useState(otherWorkThingsData)
  console.log('otherThings',otherThings);
  



  const [otherFormData, setOtherFormData] = useState(
    otherWorkThingsData.map((item) => ({
      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      painting: "",
      price: 0,
      remark: "",
    }))
  );
  console.log("otherFormData", otherWorkThingsData);
  console.log("otherFormData", otherFormData);





  const handleOtherChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value)|| 0;
    console.log('eee',newValue);
    
    // const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];

    if (otherWorkThingsData[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (otherWorkThingsData[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (otherWorkThingsData[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (otherWorkThingsData[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (otherWorkThingsData[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (otherWorkThingsData[index].measurement === "painting") {
      item[field] = newValue;
      item.price = Math.round(item.value * 3.5 * newValue);
    }

    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };


  const handleOtherPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };



  const handleOtherRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };



  const handleOtherOptionChange = (e, index) => {
    const value = e.target.value ||0;
    const selectedLabel = e.target.label;
    console.log("eee",value );
    console.log("eee",selectedLabel );
    
    
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setOtherFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (otherWorkThingsData[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (otherWorkThingsData[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (otherWorkThingsData[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (otherWorkThingsData[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (otherWorkThingsData[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      } else if (otherWorkThingsData[index].measurement === "painting") {
        item.price = Math.round(value * 3.5 * item.painting);
      }

      return newData;
    });
  };




  // const calculateOtherTotal = () => {
  //   let newTotal = 0;
  //   for (let i = 0; i < otherFormData.length; i++) {
  //     newTotal += parseInt(otherFormData[i].price);
  //   }
  //   return newTotal;
  // };

  // useEffect(() => {
  //   const newOtherTotal = calculateOtherTotal();

  //   setRoomTypePrice(newOtherTotal);
  // }, [otherFormData]); // This will update the total whenever formData changes.


  useEffect(() => {
    // Recalculate the total price
    const totalPrice = otherFormData.reduce((total, item) => total + (parseFloat(item.price) || 0), 0);
    setRoomTypePrice(totalPrice);


  }, [otherFormData]); // Recalculate when kitchenFormData changes




  const saveOtherData = async () => {

    // Recalculate prices
    const updatedLooseFormData = otherFormData.map((item, index) => {
      let newPrice = 0;

      if (otherWorkThingsData[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (otherWorkThingsData[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (otherWorkThingsData[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (otherWorkThingsData[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (otherWorkThingsData[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      } else if (otherWorkThingsData[index].measurement === "painting") {
        newPrice = Math.round(item.value * 3.5 * item.painting);
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);
    const url =`https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: otherFormData,
        roomType: roomType,
        fields: otherWorkThingsData,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
          navigation("/assigned/view-rooms", { state: data });
      }
      )
      .catch((error) => console.error('Error:', error));
  }



  // dynamic for loose furniture 

  const { looseThingsData } = useSelector(
    (state) => state.looseThings
  );
  console.log("looseThingsData", looseThingsData);




  const [looseFormData, setLooseFormData] = useState(
    looseThingsData.map((item) => ({
      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      price: 0,
      remark: "",
    }))
  );




  const handleLooseChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    if (looseThingsData[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (looseThingsData[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (looseThingsData[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (looseThingsData[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (looseThingsData[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    }

    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };


  const handleLoosePriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };



  const handleLooseRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };



  const handleLooseOptionChange = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setLooseFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (looseThingsData[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (looseThingsData[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (looseThingsData[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (looseThingsData[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (looseThingsData[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      }

      return newData;
    });
  };




  // const calculateLooseTotal = () => {
  //   let newTotal = 0;
  //   for (let i = 0; i < looseFormData.length; i++) {
  //     newTotal += parseInt(looseFormData[i].price);
  //   }
  //   return newTotal;
  // };

  // useEffect(() => {
  //   const newLooseTotal = calculateLooseTotal();

  //   setRoomTypePrice(newLooseTotal);
  // }, [looseFormData]); // This will update the total whenever formData changes.


  useEffect(() => {
    // Recalculate the total price
    const totalPrice = looseFormData.reduce((total, item) => total + item.price, 0);
    setRoomTypePrice(totalPrice);

  }, [looseFormData]); // Recalculate when kitchenFormData changes




  const saveLooseData = async () => {

    // Recalculate prices
    const updatedLooseFormData = looseFormData.map((item, index) => {
      let newPrice = 0;

      if (looseThingsData[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (looseThingsData[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (looseThingsData[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (looseThingsData[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (looseThingsData[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);

    const url =`https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`;



    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: looseFormData,
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        priceMode: priceGen,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
        
          navigation("/assigned/view-rooms", { state: data });
   
      }
      )
      .catch((error) => console.error('Error:', error));
  }



  // dynamic for Accessories

  const { accessoriesThingsData } = useSelector(
    (state) => state.accessories
  );
  console.log("accessoriesThingsData", accessoriesThingsData);




  const [accessoriesFormData, setAccessoriesFormData] = useState(
    accessoriesThingsData.map((item) => ({
      name: item.name,
      label: "",
      value: 0,
      valueIncresed: 0,
      width: "",
      height: "",
      qnty: "",
      rft: "",
      area: "",
      price: 0,
      remark: "",
    }))
  );

  console.log("accessoriesFormData", accessoriesFormData);



  const handleAccessoriesChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value)||0;
    console.log("eee",newValue);
    
    // const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    if (accessoriesThingsData[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (accessoriesThingsData[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (accessoriesThingsData[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (accessoriesThingsData[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (accessoriesThingsData[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    }

    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };


  const handleAccessoriesPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };



  const handleAccessoriesRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };



  const handleAccessoriesOptionChange = (e, index) => {
    const value = e.target.value||0;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    console.log("eee",value);
    console.log("eee",selectedLabel);
    

    setAccessoriesFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (accessoriesThingsData[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (accessoriesThingsData[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (accessoriesThingsData[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (accessoriesThingsData[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (accessoriesThingsData[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      }

      return newData;
    });
  };




  // const calculateAccessoriesTotal = () => {
  //   let newTotal = 0;
  //   for (let i = 0; i < accessoriesFormData.length; i++) {
  //     newTotal += parseInt(accessoriesFormData[i].price);
  //   }
  //   return newTotal;
  // };

  // useEffect(() => {
  //   const newAccessoriesTotal = calculateAccessoriesTotal();

  //   setRoomTypePrice(newAccessoriesTotal);
  // }, [accessoriesFormData]); // This will update the total whenever formData changes.



  useEffect(() => {
    // Recalculate the total price
    const totalPrice = accessoriesFormData.reduce((total, item) => total + (parseFloat(item.price) || 0), 0);
    setRoomTypePrice(totalPrice);

  }, [accessoriesFormData]); // Recalculate when kitchenFormData changes



  const saveAccessoriesData = async () => {

    // Recalculate prices
    const updatedLooseFormData = accessoriesFormData.map((item, index) => {
      let newPrice = 0;

      if (accessoriesThingsData[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (accessoriesThingsData[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (accessoriesThingsData[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (accessoriesThingsData[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (accessoriesThingsData[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);

    const url = `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: accessoriesFormData,
        roomType: roomType,
        fields: accessoriesThingsData,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
        
          navigation("/assigned/view-rooms", { state: data });
        
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  // name: item.name,
  // label: "",
  // value: 0,
  // valueIncresed: 0,
  // width:0,
  // height: 0,
  // qnty: 0,
  // rft:0,
  // area:0,
  // price:0,
  // remark: "",

  // adding dynamic fields for extra items
  const [materialFields, setMaterialFields] = useState([{ label: '', value: 0, qnty: 1, remark: '' }]);
  const [materialFieldsTotal, setMaterialFieldsTotal] = useState(0);

  const handleAddField = () => {
    setMaterialFields([...materialFields, { label: '', value: 0, qnty: 1, remark: '' }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = [...materialFields];
    updatedFields.splice(index, 1);
    setMaterialFields(updatedFields);
  };

  const handleFieldChange = (value, index, fieldName) => {
    const updatedFields = [...materialFields];
    updatedFields[index][fieldName] = value;
    setMaterialFields(updatedFields);
  };

  const values = materialFields.map(items => {
    return items.value;
  });
  // reducing the qty in  a single value
  const reducerOfValues = (accumulator, currentValue) =>
    accumulator + parseFloat(currentValue || 0);

  // const totalValues = values.reduce(reducerOfValues, 0);
  const totalValues = () => {
    return values.reduce(reducerOfValues, 0);
  }

  useEffect(() => {
    const newAccessoriesTotal = totalValues;

    setMaterialFieldsTotal(newAccessoriesTotal);
    setRoomTypePrice(newAccessoriesTotal);
  }, [materialFields]);


  const saveExtraItemsData = async () => {


    // Recalculate prices
    const updatedMaterialFields = materialFields.map(item => {
      const newValue = parseFloat(item.value) || 0;
      const newQnty = parseFloat(item.qnty) || 1;
      const newPrice = Math.round(newValue * newQnty);

      return { ...item, value: newValue, qnty: newQnty, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedMaterialFields.reduce((total, item) => total + item.price, 0);

    const url =`https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: materialFields,
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(() => {
        setRoomTypeWoodPrice(0);
          navigation("/assigned/view-rooms", { state: data });
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  // const [value, setValue] = useState("newPrice"); // Default value: "New Price"

  // // Log the selected value for debugging
  // console.log("Selected Price Type:", value);

  // // Handler for dropdown change

  const [priceGen, setPriceGen] = useState(OriginalPriceType || "" || data.priceMode);
  // console.log("OriginalPriceType", OriginalPriceType);
  // console.log("OriginalPriceType priceGen", priceGen);


  const handleChange = (event) => {
    const selectedValue = event.target.value; // Access the selected value directly
    setPriceGen(selectedValue)

    // setPriceGen(selectedValue); // Update the state
  };






  // console.log("bedroomThingsDataCopy", bedroomThingsDataCopy);


  //////////////////////////add new label ///////////////////////
  // const handleAddNewItem = async (item, index) => {
  //   const material = item.material
  //   const ShapeOfKitchen = item.name ==="Shape Of Kitchen"
  //   console.log("ShapeOfKitchen", ShapeOfKitchen);

  //   const { value: formValues } = await Swal.fire({
  //     title: 'Add New Item',
  //     html:
  //       '<input id="swal-input1" class="swal2-input" placeholder="Label">' +
  //       '<input id="swal-input2" class="swal2-input" placeholder="Value">',
  //     focusConfirm: false,
  //     preConfirm: () => {
  //       const label = document.getElementById('swal-input1').value;
  //       const value = document.getElementById('swal-input2').value;

  //       if (!label || !value) {
  //         Swal.showValidationMessage('Both fields are required');
  //         return false;
  //       }

  //         return {
  //           label,
  //           value:value,
  //           oldvalue:value
  //         };
  //     },
  //     showCancelButton: true,
  //     confirmButtonText: 'Add'
  //   });

  //   if (formValues) {
  //     console.log('New Item:', formValues);

  //     let updatedFormData;
  //     let setDataFn;
  //     // const matchedMaterial = material[index]
  //     console.log("updatedFormData", updatedFormData);
  //     console.log("item.table", item.table);


  //     switch (item.table) {
  //       case "kitchen":
  //         updatedFormData = [...kitchenThingsDataCopy];
  //         setDataFn = setKitchenThingsDataCopy;
  //         break;
  //       case "Bedroom":
  //         updatedFormData = [...bedroomThingsDataCopy];
  //         setDataFn = setBedroomThingsDataCopy;
  //         break;
  //       case "Foyer":
  //         updatedFormData = [...foyerThingsDataCopy];
  //         setDataFn = setFoyerThingsDataCopy;
  //         break;
  //       case "LivingRoom":
  //         updatedFormData = [...livingThingsDataCopy];
  //         setDataFn = setLivingThingsDataCopy;
  //         break;

  //     }
  //     // Create a shallow copy of the array

  //     // Clone the object you're updating
  //     const current = {
  //       ...updatedFormData[index],
  //       material: [...(material || []), formValues],
  //     };

  //     // Update the array with the new object
  //     updatedFormData[index] = current;

  //     setDataFn(updatedFormData);
  //     console.log("updatedFormData", updatedFormData);
  //   }
  // };


  const handleAddNewItem = async (item,name , index) => {
       console.log(item);
    console.log(name);
    console.log(index);
    const material = item.material;
    const ShapeOfKitchen = item.name === "Shape Of Kitchen";
    // console.log("ShapeOfKitchen", ShapeOfKitchen);

        const swalHtml = ShapeOfKitchen
      ? '<input id="swal-input1" class="swal2-input" placeholder="Label">'
      : '<input id="swal-input1" class="swal2-input" placeholder="Label">' +
      '<input id="swal-input2" class="swal2-input" placeholder="Value (numbers only)">';

    const { value: formValues } = await Swal.fire({
      title: `Add New Material (${item.name})`,
      html:swalHtml,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Add',
      preConfirm: () => {
        const label = document.getElementById('swal-input1').value.trim();
        const value = document.getElementById('swal-input2').value.trim();

        const labelRegex = /^[a-zA-Z\s]+$/; // Only letters and spaces
        const valueRegex = /^[0-9]+(\.[0-9]+)?$/; // Only numbers (integer or decimal)

        if (!label || !value) {
          Swal.showValidationMessage('Both fields are required');
          return false;
        }

        if (!labelRegex.test(label)) {
          Swal.showValidationMessage('Label must contain only letters and spaces');
          return false;
        }

        if (!valueRegex.test(value)) {
          Swal.showValidationMessage('Value must contain only numbers');
          return false;
        }

        return {
          label,
          value,
          oldvalue: value
        };
      }
    });

    if (formValues) {
      // console.log('New Item:', formValues);

      let updatedFormData;
      let setDataFn;

      // console.log("item.table", item.table);

      switch (item.table || name) {
        case "kitchen":
          updatedFormData = [...kitchenThingsDataCopy];
          setDataFn = setKitchenThingsDataCopy;
          break;
        case "Bedroom":
          updatedFormData = [...bedroomThingsDataCopy];
          setDataFn = setBedroomThingsDataCopy;
          break;
        case "Foyer":
          updatedFormData = [...foyerThingsDataCopy];
          setDataFn = setFoyerThingsDataCopy;
          break;
        case "LivingRoom":
          updatedFormData = [...livingThingsDataCopy];
          setDataFn = setLivingThingsDataCopy;
          break;
          case "OtherWorks":
          updatedFormData = [...otherThings];
          setDataFn = setOtherThings ;
          break;
        default:
          // console.error("Unknown table type:", item.table);
          return;
      }

      const current = {
        ...updatedFormData[index],
        material: [...(material || []), formValues],
      };

      updatedFormData[index] = current;
      setDataFn(updatedFormData);
      console.log("updatedFormData", updatedFormData);
    }
  };

  ///////////////////////////////////////////////////////////


  const [search, setSearch] = useState('');
  // const [filteredDataField, setFilteredDataField] = useState([]);

  // console.log('filteredDataFieldddddd', filteredDataField);
  // useEffect(() => {
  //   sortedData();
  // }, [roomTypeModal]); // Include roomTypeModal as a dependency


  // const sortedData = () => {
  //   const requiredFields = ['area', 'height', 'qnty', 'rft', 'width'];

  //   let shotData = [];
  //   let setFormFn = null;
  //   let fields = [];

  //   switch (roomTypeModal) {
  //     case 'Kitchen':
  //       shotData = kitchenFormData;
  //       setFormFn = setKitchenFormData;
  //       fields = kitchenThingsDataCopy;
  //       break;
  //     case 'Bedroom':
  //       shotData = bedroomFormData;
  //       setFormFn = setBedroomFormData;
  //       fields = bedroomThingsDataCopy;
  //       break;
  //     case 'Foyer':
  //       shotData = foyerFormData;
  //       setFormFn = setFoyerFormData;
  //       fields = foyerThingsDataCopy;
  //       break;
  //     case 'Living Room':
  //       shotData = livingFormData;
  //       setFormFn = setLivingFormData;
  //       fields = livingThingsDataCopy;
  //       break;
  //     case 'Other Works':
  //       shotData = otherFormData;
  //       setFormFn = setOtherFormData;
  //       fields = otherWorkThingsData;
  //       break;
  //     case 'Loose Furniture':
  //       shotData = looseFormData;
  //       setFormFn = setLooseFormData;
  //       fields = looseThingsData;
  //       break;
  //     case 'Accessories':
  //       shotData = accessoriesFormData;
  //       setFormFn = setAccessoriesFormData;
  //       fields = accessoriesThingsData;
  //       break;
  //     default:
  //       return;
  //   }

  //   // ✅ FIX: Correct isFilled logic (without .some)
  //   const isFilled = (obj) => {
  //     for (let i = 0; i < requiredFields.length; i++) {
  //       const val = obj[requiredFields[i]];
  //       if (val !== '' && val !== null && val !== undefined && val !== 0) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   };

  //   const sorted = [...shotData].sort((a, b) => {
  //     const aFilled = isFilled(a);
  //     const bFilled = isFilled(b);

  //     if (aFilled === bFilled) return 0;
  //     return aFilled ? -1 : 1; // Filled items come first
  //   });

  //   // 🔍 Optional debug logs (can be removed later)
  //   console.log("Sorted Filled Data:", sorted);

  //   // Create a map for fast field lookup
  //   const fieldMap = new Map();
  //   fields?.forEach((item) => fieldMap.set(item.name, item));

  //   // Reorder fields based on sorted data
  //   const filteredDataFields = sorted
  //     .map((item) => fieldMap.get(item.name))
  //     .filter(Boolean); // remove any undefined values

  //   // Set states
  //   if (setFormFn) {
  //     setFormFn(sorted);
  //   }
  //   setFilteredDataField(filteredDataFields);
  // };


  return (
    <Container fluid>
      <Row className='m-0 ' >
        <Col sm={1} >

        </Col>


        <Col sm={11}>

          <Row className="p-4">
            <Row style={{ padding: '10px 0 0 0' }}>
              <hr />
              <Col sm={11}>
                <Breadcrumb  >
                  <Breadcrumb.Item
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      textDecoration: "none",
                      backgroundColor: "#ea6e2b",
                      borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                      height: 30,
                      width: "auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer", // Pointer on hove
                      marginLeft: "10px",
                      padding: '1rem',

                      // Hover effect
                      ":hover": {
                        backgroundColor: "#FFA500", // Change background color on hover
                        transform: "scale(1.1)", // Slightly increase the size on hover
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                      }
                    }} href="/assigned">{"Assign Projects"} </Breadcrumb.Item>
                  <Breadcrumb.Item

                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      marginLeft: "20px", // Space between elements
                      textDecoration: "none",
                      backgroundColor: "#ea6e2b",
                      borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                      height: 30,
                      width: 'auto',
                      display: "flex",
                      justifyContent: "center",
                      padding: '1rem',
                      alignItems: "center",
                      cursor: "pointer", // Pointer on hove
                      marginLeft: "10px",

                      // Hover effect
                      ":hover": {
                        backgroundColor: "#FFA500", // Change background color on hover
                        transform: "scale(1.1)", // Slightly increase the size on hover
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                      }
                    }}
                    onClick={() =>
                      navigation("/assigned/view-rooms", { state: data })
                    }
                  >
                    {data.pname}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item

                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      marginLeft: "20px", // Space between elements
                      textDecoration: "none",
                      backgroundColor: "#ea6e2b",
                      borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                      height: 30,
                      width: 'auto',
                      display: "flex",
                      padding: '1rem',
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer", // Pointer on hove
                      marginLeft: "10px",

                      // Hover effect
                      ":hover": {
                        backgroundColor: "#FFA500", // Change background color on hover
                        transform: "scale(1.1)", // Slightly increase the size on hover
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                      }
                    }} active>Add Room  ({roomTypeDesign})</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              <hr />

            </Row>
            {/* Room name and type modal */}
            {roomTypeModal == '' ?
              <Row style={{ overflowY: 'auto', paddingTop: '5vh' }}>

                <Row >

                  <Col
                    sm={12}
                  >
                    <Container >
                      <Row style={{
                        width: '100%',
                        padding: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color
                        marginBottom: '10px'

                      }}>
                        <Col>

                          <Col style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                          }} >
                            <Col>
                              <h4 style={{ color: '#e85d13' }} >What is this design option for?</h4>
                            </Col>


                          </Col>
                          <Form onSubmit={handleRoomTypeSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                              <Form.Label>Room Type</Form.Label>

                              <Form.Select
                                value={roomType}
                                onChange={(e) => setRoomType(e.currentTarget.value)}
                                aria-label="Default select example"
                                required

                              >
                                <option>Select a Room</option>
                                <option value="Kitchen">Kitchen</option>
                                <option value="Bedroom">Bedroom</option>
                                <option value="Foyer">Foyer</option>
                                <option value="Living Room">Living Room</option>
                                <option value="Other Works">Other Works</option>
                                <option value="Loose Furniture">Loose Furniture</option>
                                <option value="Accessories">Accessories</option>
                                <option value="ExtraItems">Extra items</option>
                              </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Label>Room Name</Form.Label>
                              <Form.Control
                                type="text"
                                value={roomTypeName}
                                onChange={(e) => setRoomTypeName(e.target.value)}
                                placeholder="Kitchen / Bedroom / Foyer / Living Room / Other Works / Loose Furniture"
                                required
                              />
                            </Form.Group>
                            {!OriginalPriceType && <Col>
                              <Form.Group controlId="price-selector">
                                <Form.Label>Price Type</Form.Label>
                                <Form.Control
                                  className="w-50"
                                  as="select"
                                  name="price"
                                  value={priceGen}
                                  onChange={handleChange}
                                >
                                  <option value="">None</option>
                                  <option value="oldvalue">Old Price</option>
                                  <option value="value">New Price</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>}

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Label>Design options</Form.Label>
                              <Form.Control
                                type="text"
                                value={roomTypeDesign}
                                onChange={(e) => setRoomTypeDesign(e.target.value)}
                                placeholder="Lorraine U, Damaris Straight..."
                                required={false}
                              />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Label>Description</Form.Label>
                              <Form.Control
                                as="textarea"
                                value={roomTypeDescription}
                                onChange={(e) => setRoomTypeDescription(e.target.value)}
                                placeholder="Description"
                                required
                              />
                            </Form.Group>

                            <Form.Group>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                              }}>
                                <button
                                  style={{
                                    width: '20vw'
                                  }}

                                  className="buttonDesign"
                                  onClick={() => handleRoomTypeCancel()}
                                >
                                  Cancel
                                </button>
                                <button
                                  style={{
                                    width: '20vw',
                                    border: '1px solid green'
                                  }}
                                  className="buttonDesign"
                                  onClick={() => handleSaveNameType()}
                                  disabled={!roomType || !roomTypeDesign || !roomTypeName || !priceGen}
                                >
                                  Save
                                </button>
                                <button
                                  style={{
                                    width: '20vw',
                                    border: '1px solid blue'
                                  }}
                                  className="buttonDesign"
                                  onClick={() => setRoomTypeModal(roomType)}
                                  disabled={!roomType || !roomTypeDesign || !roomTypeName || !priceGen}
                                >
                                  Next
                                </button>
                              </div>
                            </Form.Group>
                          </Form>
                        </Col>
                      </Row>
                    </Container>


                  </Col>
                </Row>


              </Row> : roomTypeModal == 'Kitchen' ?
                <Row
                  style={{
                    // marginBottom: '50px',
                    // height:'auto',

                    padding: '20px',
                    // marginLeft: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffff', // Light background color

                  }} >
                  <div style={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0.5rem'
                  }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Kitchen -- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>
                    <Form>
                      <InputGroup>
                        <Form.Control
                          style={{
                            borderRadius: "15px",
                            padding: "12px 15px",
                            border: "1px solid #d1d5db",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                            transition: "all 0.3s ease",
                            width: "20vw",
                          }}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search Labels"
                        />
                      </InputGroup>
                    </Form>
                  </div>




                  <Row style={{
                    backgroundColor: "#F2F2F2",
                    height: 'auto',
                    marginLeft: '5px',
                    overflowY: 'auto',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '15px',
                    // padding: '0 0 0 10px',
                  }}>
                    <Col style={{ minHeight: 380, maxHeight: 480 }}>

                      <Form>

                        <Form.Group>
                          <Row>

                            <Col sm={12}>

                              {kitchenThingsDataCopy
                                .map((item, index) => ({ item, formData: kitchenFormData[index], index }))
                                .filter(({ item }) => {
                                  const searchQuery = search.toLowerCase();
                                  return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery)
                                })
                                .map(({ item, formData, index }) => (
                                  item.measurement == "area" ?
                                    <Row className="mx-1 my-3">
                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Label
                                            style={{
                                              fontSize: 16,
                                              fontWeight: "500",
                                            }}
                                          >
                                            <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                          </Form.Label>
                                        </Form.Group>
                                      </Col>

                                      {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                          value={kitchenFormData[index].value}
                                          onChange={(e) => handleKitchenOptionChange(e, index)}


                                        >
                                          {kitchenFormData[index].label !== 0 ? (
                                            <option value={kitchenFormData[index].label}>
                                              {kitchenFormData[index].label}
                                            </option>

                                          ) : (
                                            <option value="0">None</option>
                                          )}

                                          {item.material.map((item2, index2) => (
                                            <option
                                              key={index2}
                                              value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                            >
                                              {item2.label}

                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}

                                      {/* add label option */}
                                      <Col sm={2} style={{ display: 'flex' }}>
                                        <Dropdown>
                                          <Dropdown.Toggle
                                            variant="outline-secondary"
                                            style={{
                                              width: '12vw',
                                              backgroundColor: 'white',
                                              color: 'black',
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              whiteSpace: 'normal',        // Allows text to wrap
                                              wordBreak: 'break-word',     // Breaks long words
                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                            }}>
                                            {formData.label || 'None'}
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                            <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                              None
                                            </Dropdown.Item>
                                            {item.material.map((item2, index2) => (
                                              <Dropdown.Item
                                                key={index2}
                                                onClick={() =>
                                                  handleKitchenOptionChange(
                                                    {
                                                      target: {
                                                        value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                        label: item2.label
                                                      }
                                                    },
                                                    index
                                                  )
                                                }
                                              >
                                                {item2.label}
                                              </Dropdown.Item>
                                            ))}

                                            <Dropdown.Divider />

                                            <div className="px-3 py-2">
                                              <Button
                                                variant="outline-success"
                                                size="sm"
                                                onClick={(e) => {
                                                  e.stopPropagation(); // prevent dropdown from closing
                                                  handleAddNewItem(item, 'kitchen', index); // define this function
                                                }}
                                              >
                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                              </Button>
                                            </div>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Control
                                            type="number"
                                            value={kitchenFormData[index].area}
                                            onChange={(e) => handleKitchenChange(e, index, "area")}
                                            placeholder="Area"
                                          />
                                        </Form.Group>
                                      </Col>

                                      <Col sm={1}>

                                      </Col>

                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Control
                                            type="number"
                                            value={kitchenFormData[index].price}
                                            //  onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                            placeholder="Price"
                                            disabled={kitchenFormData[index].value ? false : true}

                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Control

                                            value={kitchenFormData[index].remark}
                                            onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                            as="textarea" rows={1}
                                            placeholder="Remark"
                                          />

                                        </Form.Group>


                                      </Col>
                                      <Col sm={1}>
                                        {item.isUserAdded && (
                                          <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                            <i class="bi bi-x-circle-fill"></i>
                                          </Button>
                                        )}
                                      </Col>
                                    </Row>
                                    : item.measurement == "width" ?
                                      <Row className="mx-1 my-3">
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Label
                                              style={{
                                                fontSize: 16,
                                                fontWeight: "500",
                                              }}
                                            >
                                              <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                            </Form.Label>
                                          </Form.Group>
                                        </Col>

                                        {/* <Col sm={2}>
                                        <Form.Group>
                                          <Form.Select
                                            value={kitchenFormData[index].value}
                                            onChange={(e) => handleKitchenOptionChange(e, index)}


                                          >
                                            <option value="0">None</option>
                                            {item.material.map((item2, index2) => (
                                              <option
                                                key={index2}
                                                value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                              >
                                                {item2.label}
                                              </option>
                                            ))}

                                          </Form.Select>
                                        </Form.Group>
                                      </Col> */}

                                        {/* add label option */}
                                        <Col sm={2} style={{ display: 'flex' }}>
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="outline-secondary"
                                              style={{
                                                width: '12vw',
                                                backgroundColor: 'white',
                                                color: 'black',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                whiteSpace: 'normal',        // Allows text to wrap
                                                wordBreak: 'break-word',     // Breaks long words
                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                              }}>
                                              {formData.label || 'None'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                              <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                None
                                              </Dropdown.Item>
                                              {item.material.map((item2, index2) => (
                                                <Dropdown.Item
                                                  key={index2}
                                                  onClick={() =>
                                                    handleKitchenOptionChange(
                                                      {
                                                        target: {
                                                          value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                          label: item2.label
                                                        }
                                                      },
                                                      index
                                                    )
                                                  }
                                                >
                                                  {item2.label}
                                                </Dropdown.Item>
                                              ))}

                                              <Dropdown.Divider />

                                              <div className="px-3 py-2">
                                                <Button
                                                  variant="outline-success"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    e.stopPropagation(); // prevent dropdown from closing
                                                    handleAddNewItem(item,'kitchen', index);
                                                  }}
                                                >
                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                </Button>
                                              </div>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </Col>
                                        <Col sm={1}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].width}
                                              onChange={(e) => handleKitchenChange(e, index, "width")}
                                              placeholder="Width"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={1}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].height}
                                              onChange={(e) => handleKitchenChange(e, index, "height")}
                                              placeholder="Height"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={1}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].qnty}
                                              onChange={(e) => handleKitchenChange(e, index, "qnty")}
                                              placeholder="Qty"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].price}
                                              // onChange={(e) => handleKitchenPriceChange(e, index, "price")} 
                                              placeholder="Price"
                                              disabled={kitchenFormData[index].value ? false : true}
                                              min={123}
                                              autoFocus={true}
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              value={kitchenFormData[index].remark}
                                              onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                              as="textarea" rows={1}
                                              placeholder="Remark"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={1}>
                                          {item.isUserAdded && (
                                            <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                              <i class="bi bi-x-circle-fill"></i>
                                            </Button>
                                          )}
                                        </Col>
                                      </Row>
                                      : item.measurement == "qty" ?
                                        <Row className="mx-1 my-3">
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Label
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: "500",
                                                }}
                                              >
                                                <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                              </Form.Label>
                                            </Form.Group>
                                          </Col>
                                          {/* <Col sm={2}>
                                          <Form.Group>
                                            <Form.Select
                                              value={kitchenFormData[index].value}
                                              onChange={(e) => handleKitchenOptionChange(e, index)}


                                            >
                                              <option value="0">None</option>
                                              {item.material.map((item2, index2) => (
                                                <option
                                                  key={index2}
                                                  value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                >
                                                  {item2.label}
                                                </option>
                                              ))}

                                            </Form.Select>
                                          </Form.Group>
                                        </Col> */}
                                          {/* add label option */}
                                          <Col sm={2} style={{ display: 'flex' }}>
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                variant="outline-secondary"
                                                style={{
                                                  width: '12vw',
                                                  backgroundColor: 'white',
                                                  color: 'black',
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                  wordBreak: 'break-word',     // Breaks long words
                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                }}>
                                                {formData.label || 'None'}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                  None
                                                </Dropdown.Item>
                                                {item.material.map((item2, index2) => (
                                                  <Dropdown.Item
                                                    key={index2}
                                                    onClick={() =>
                                                      handleKitchenOptionChange(
                                                        {
                                                          target: {
                                                            value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                            label: item2.label
                                                          }
                                                        },
                                                        index
                                                      )
                                                    }
                                                  >
                                                    {item2.label}
                                                  </Dropdown.Item>
                                                ))}

                                                <Dropdown.Divider />

                                                <div className="px-3 py-2">
                                                  <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                      e.stopPropagation(); // prevent dropdown from closing
                                                      handleAddNewItem(item,'kitchen',  index); // define this function
                                                    }}
                                                  >
                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                  </Button>
                                                </div>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={kitchenFormData[index].qnty || 0}
                                                onChange={(e) => handleKitchenChange(e, index, "qnty")}
                                                placeholder="Qty"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>

                                          </Col>

                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={kitchenFormData[index].price}
                                                //  onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                placeholder="Price"
                                                disabled={kitchenFormData[index].value ? false : true}
                                                min={123}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                value={kitchenFormData[index].remark}
                                                onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                as="textarea" rows={1}
                                                placeholder="Remark"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={1}>
                                            {item.isUserAdded && (
                                              <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                <i class="bi bi-x-circle-fill"></i>
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                        : item.measurement == "length" ?
                                          <Row className="mx-1 my-3">
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={kitchenFormData[index].value}
                                                onChange={(e) => handleKitchenOptionChange(e, index)}


                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => (
                                                    <Dropdown.Item
                                                      key={index2}
                                                      onClick={() =>
                                                        handleKitchenOptionChange(
                                                          {
                                                            target: {
                                                              value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                              label: item2.label
                                                            }
                                                          },
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {item2.label}
                                                    </Dropdown.Item>
                                                  ))}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item,'kitchen',  index); // define this function
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={kitchenFormData[index].height}
                                                  onChange={(e) => handleKitchenChange(e, index, "height")}
                                                  placeholder="Length"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={kitchenFormData[index].width}
                                                  onChange={(e) => handleKitchenChange(e, index, "width")}
                                                  placeholder="Width"
                                                />
                                              </Form.Group>
                                            </Col>


                                            <Col sm={1}>

                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={kitchenFormData[index].price}
                                                  // onChange={(e) => handleKitchenPriceChange(e, index, "price")} 
                                                  placeholder="Price"
                                                  disabled={kitchenFormData[index].value ? false : true}
                                                  min={123}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={kitchenFormData[index].remark}
                                                  onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row> : item.measurement == "rft" ?
                                            <Row className="mx-1 my-3">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={kitchenFormData[index].value}
                                                  onChange={(e) => handleKitchenOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => (
                                                      <Dropdown.Item
                                                        key={index2}
                                                        onClick={() =>
                                                          handleKitchenOptionChange(
                                                            {
                                                              target: {
                                                                value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                label: item2.label
                                                              }
                                                            },
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {item2.label}
                                                      </Dropdown.Item>
                                                    ))}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item,'kitchen',  index); // define this function
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={kitchenFormData[index].rft}
                                                    onChange={(e) => handleKitchenChange(e, index, "rft")}
                                                    placeholder="RFT"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={kitchenFormData[index].price}
                                                    // onChange={(e) => handleKitchenPriceChange(e, index, "price")} 
                                                    placeholder="Price"
                                                    disabled={kitchenFormData[index].value ? false : true}
                                                    min={123}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={kitchenFormData[index].remark}
                                                    onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row> : item.measurement == "selection" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    >
                                                      <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>


                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => (
                                                        <Dropdown.Item
                                                          key={index2}
                                                          onClick={() =>
                                                            handleKitchenOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                  label: item2.label
                                                                }
                                                              },
                                                              index
                                                            )
                                                          }
                                                        >
                                                          {item2.label}
                                                        </Dropdown.Item>
                                                      ))}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item,'kitchen',  index); // define this function
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>


                                                <Col sm={2}>

                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>

                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={kitchenFormData[index].remark}
                                                      onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row> : null
                                ))}


                            </Col>
                            {/* <button onClick={addNewKitchen}>Add New Accessory</button> */}
                          </Row>
                          <Row>
                            <Col>

                              <Row className="mx-1 my-3">
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemName}
                                      onChange={(e) => setExtraItemName(e.target.value)}
                                      type="text"
                                      placeholder="Item Name"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemMaterialName}
                                      onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                      type="text"
                                      placeholder="Material Name"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemMaterialValue}
                                      onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                      type="number"
                                      placeholder="Material Value"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col sm={3}>
                                  <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                    <option>Select Measurement Type</option>
                                    <option value="area">Area</option>
                                    <option value="width">Width &  Height</option>
                                    <option value="rft">RFT</option>
                                    <option value="qty">Quantity</option>
                                    <option value="length">Width & Length</option>
                                    <option value="selection">Selection</option>
                                  </Form.Select>
                                </Col>
                                <Col sm={1}>
                                  <Form.Check
                                    inline
                                    label="Wood"
                                    name="Wood"
                                    type="checkbox"
                                    id="inline-checkbox-1"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                  />
                                </Col>
                                <Col sm={2}>
                                  <Button onClick={addNewKitchenItem}>Add Item</Button>
                                </Col>
                              </Row>





                            </Col>

                          </Row>

                        </Form.Group>


                      </Form>

                    </Col>
                  </Row>
                  <Row style={{
                    // marginBottom: '50px',
                    marginLeft: '1px',
                    padding: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color


                  }} >
                    <Col style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                    }}>
                      <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                      <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveKitchenData()} >Save</Button>
                    </Col>
                    <Col className="col-sm-3">

                    </Col>
                    <Col className="col-sm-2"><h4>Total Price</h4></Col>
                    <Col className="col-sm-2">
                      {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                    </Col>
                  </Row>

                </Row> : roomTypeModal == 'Bedroom' ?
                  <Row className="p-2" style={{
                    marginBottom: '50px',
                    padding: '20px',
                    marginLeft: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color

                  }}>

                    <div style={{
                      display: "flex",
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '1rem'
                    }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Bedroom -- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                      <Form>
                        <InputGroup>
                          <Form.Control
                            style={{
                              borderRadius: "15px",
                              padding: "12px 15px",
                              border: "1px solid #d1d5db",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                              background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                              transition: "all 0.3s ease",
                              width: "20vw",
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search Labels"
                          />
                        </InputGroup>
                      </Form>
                    </div>


                    <Row style={{
                      backgroundColor: "#F2F2F2",
                      height: 'auto',
                      marginLeft: '5px',
                      overflowY: 'auto',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                      borderRadius: '15px',
                      padding: '0 0 0 10px',
                    }}>
                      <Col style={{ minHeight: 380, maxHeight: 480 }}>

                        <Form>

                          <Form.Group>
                            <Row>

                              <Col sm={12}>

                                {bedroomThingsDataCopy
                                  .map((item, index) => ({ item, formData: bedroomFormData[index], index }))
                                  .filter(({ item }) => {
                                    const searchQuery = search.toLowerCase();
                                    return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                  })
                                  .map(({ item, formData, index }) => (
                                    item.measurement == "area" ?
                                      <Row className="mx-1 my-3">
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Label
                                              style={{
                                                fontSize: 16,
                                                fontWeight: "500",
                                              }}
                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                            </Form.Label>
                                          </Form.Group>
                                        </Col>
                                        {/* <Col sm={2}>
                                        <Form.Group>
                                          <Form.Select
                                            style={{
                                              backgroundColor: "red"
                                            }}
                                            value={bedroomFormData[index].value}
                                            onChange={(e) => handleBedroomOptionChange(e, index)}


                                          >
                                            <option value="0">None</option>
                                            {item.material.map((item2, index2) => (
                                              <option
                                                key={index2}
                                                value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                              >
                                                {item2.label}
                                              </option>
                                            ))}

                                          </Form.Select>
                                        </Form.Group>
                                      </Col> */}

                                        {/* add label option */}
                                        <Col sm={2} style={{ display: 'flex' }}>
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="outline-secondary"
                                              style={{
                                                width: '12vw',
                                                backgroundColor: 'white',
                                                color: 'black',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                whiteSpace: 'normal',        // Allows text to wrap
                                                wordBreak: 'break-word',     // Breaks long words
                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                              }}>
                                              {formData.label || 'None'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                              <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                None
                                              </Dropdown.Item>
                                              {item.material.map((item2, index2) => (
                                                <Dropdown.Item
                                                  key={index2}
                                                  onClick={() =>
                                                    handleBedroomOptionChange(
                                                      {
                                                        target: {
                                                          value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                          label: item2.label
                                                        }
                                                      },
                                                      index
                                                    )
                                                  }
                                                >
                                                  {item2.label}
                                                </Dropdown.Item>
                                              ))}

                                              <Dropdown.Divider />

                                              <div className="px-3 py-2">
                                                <Button
                                                  variant="outline-success"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    e.stopPropagation(); // prevent dropdown from closing
                                                    handleAddNewItem(item,'Bedroom', index);
                                                  }}
                                                >
                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                </Button>
                                              </div>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={bedroomFormData[index].area}
                                              onChange={(e) => handleBedroomChange(e, index, "area")}
                                              placeholder={"Area"}
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={1}>

                                        </Col>

                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={bedroomFormData[index].price}
                                              onChange={(e) => handleBedroomChange(e, index, "price")}
                                              placeholder="Price"
                                              disabled={!bedroomFormData[index].value}

                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              value={bedroomFormData[index].remark}
                                              onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                              as="textarea" rows={1}
                                              placeholder="Remark"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={1}>
                                          {item.isUserAdded && (
                                            <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                              <i class="bi bi-x-circle-fill"></i>
                                            </Button>
                                          )}
                                        </Col>
                                      </Row>
                                      : item.measurement == "width" ?
                                        <Row className="mx-1 my-3">
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Label
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: "500",
                                                }}
                                              > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                              </Form.Label>
                                            </Form.Group>
                                          </Col>
                                          {/* <Col sm={2}>
                                          <Form.Group>
                                            <Form.Select
                                              value={bedroomFormData[index].value}
                                              onChange={(e) => handleBedroomOptionChange(e, index)}


                                            >
                                              <option value="0">None</option>
                                              {item.material.map((item2, index2) => (
                                                <option
                                                  key={index2}
                                                  value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                >
                                                  {item2.label}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        </Col> */}

                                          {/* add label option */}
                                          <Col sm={2} style={{ display: 'flex' }}>
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                variant="outline-secondary"
                                                style={{
                                                  width: '12vw',
                                                  backgroundColor: 'white',
                                                  color: 'black',
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                  wordBreak: 'break-word',     // Breaks long words
                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                }}>
                                                {formData.label || 'None'}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                  None
                                                </Dropdown.Item>
                                                {item.material.map((item2, index2) => (
                                                  <Dropdown.Item
                                                    key={index2}
                                                    onClick={() =>
                                                      handleBedroomOptionChange(
                                                        {
                                                          target: {
                                                            value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                            label: item2.label
                                                          }
                                                        },
                                                        index
                                                      )
                                                    }
                                                  >
                                                    {item2.label}
                                                  </Dropdown.Item>
                                                ))}

                                                <Dropdown.Divider />

                                                <div className="px-3 py-2">
                                                  <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                      e.stopPropagation(); // prevent dropdown from closing
                                                      handleAddNewItem(item,'Bedroom', index);
                                                    }}
                                                  >
                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                  </Button>
                                                </div>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                          <Col sm={1}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].width}
                                                onChange={(e) => handleBedroomChange(e, index, "width")}
                                                placeholder="Width"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].height}
                                                onChange={(e) => handleBedroomChange(e, index, "height")}
                                                placeholder="Height"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].qnty}
                                                onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                placeholder="Qty"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].price}
                                                // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                placeholder="Price"
                                                disabled={bedroomFormData[index].value ? false : true}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                value={bedroomFormData[index].remark}
                                                onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                as="textarea" rows={1}
                                                placeholder="Remark"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={1}>
                                            {item.isUserAdded && (
                                              <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                <i class="bi bi-x-circle-fill"></i>
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                        : item.measurement == "qty" ?
                                          <Row className="mx-1 my-3">
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={bedroomFormData[index].value}
                                                onChange={(e) => handleBedroomOptionChange(e, index)}


                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => (
                                                    <Dropdown.Item
                                                      key={index2}
                                                      onClick={() =>
                                                        handleBedroomOptionChange(
                                                          {
                                                            target: {
                                                              value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                              label: item2.label
                                                            }
                                                          },
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {item2.label}
                                                    </Dropdown.Item>
                                                  ))}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item,'Bedroom', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={bedroomFormData[index].qnty}
                                                  onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                  placeholder="Qty"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>

                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={bedroomFormData[index].price}
                                                  // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                  placeholder="Price"
                                                  disabled={bedroomFormData[index].value ? false : true}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={bedroomFormData[index].remark}
                                                  onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                          : item.measurement == "length" ?
                                            <Row className="mx-1 my-3">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={bedroomFormData[index].value}
                                                  onChange={(e) => handleBedroomOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => (
                                                      <Dropdown.Item
                                                        key={index2}
                                                        onClick={() =>
                                                          handleBedroomOptionChange(
                                                            {
                                                              target: {
                                                                value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                label: item2.label
                                                              }
                                                            },
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {item2.label}
                                                      </Dropdown.Item>
                                                    ))}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item,'Bedroom', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={bedroomFormData[index].height}
                                                    onChange={(e) => handleBedroomChange(e, index, "height")}
                                                    placeholder="Length"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={bedroomFormData[index].width}
                                                    onChange={(e) => handleBedroomChange(e, index, "width")}
                                                    placeholder="Width"
                                                  />
                                                </Form.Group>
                                              </Col>


                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={bedroomFormData[index].price}
                                                    // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={bedroomFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={bedroomFormData[index].remark}
                                                    onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row> : item.measurement == "rft" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={bedroomFormData[index].value}
                                                    onChange={(e) => handleBedroomOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => (
                                                        <Dropdown.Item
                                                          key={index2}
                                                          onClick={() =>
                                                            handleBedroomOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                  label: item2.label
                                                                }
                                                              },
                                                              index
                                                            )
                                                          }
                                                        >
                                                          {item2.label}
                                                        </Dropdown.Item>
                                                      ))}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item,'Bedroom', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={bedroomFormData[index].rft}
                                                      onChange={(e) => handleBedroomChange(e, index, "rft")}
                                                      placeholder="RFT"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={bedroomFormData[index].price}
                                                      // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={bedroomFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={bedroomFormData[index].remark}
                                                      onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row> : item.measurement == "door" ?
                                                <Row className="mx-1 my-3">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={bedroomFormData[index].value}
                                                      onChange={(e) => handleBedroomOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => (
                                                          <Dropdown.Item
                                                            key={index2}
                                                            onClick={() =>
                                                              handleBedroomOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                    label: item2.label
                                                                  }
                                                                },
                                                                index
                                                              )
                                                            }
                                                          >
                                                            {item2.label}
                                                          </Dropdown.Item>
                                                        ))}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item,'Bedroom', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={bedroomFormData[index].value2}
                                                        onChange={(e) => handleBedroomOption2Change(e, index)}

                                                        disabled={bedroomFormData[index].price == 0 ? true : false}
                                                      >
                                                        <option value="0">None</option>
                                                        {item.door.map((item3, index3) => (
                                                          <option value={item3.value} key={index3}>{item3.label}</option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].width}
                                                        onChange={(e) => handleBedroomChange(e, index, "width")}
                                                        placeholder="Width"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].height}
                                                        onChange={(e) => handleBedroomChange(e, index, "height")}
                                                        placeholder="Height"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].qnty}
                                                        onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].price}
                                                        // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={bedroomFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={bedroomFormData[index].remark}
                                                        onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row> : item.measurement == "selection" ?
                                                  <Row className="mx-1 my-3">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>


                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => (
                                                            <Dropdown.Item
                                                              key={index2}
                                                              onClick={() =>
                                                                handleBedroomOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                      label: item2.label
                                                                    }
                                                                  },
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {item2.label}
                                                            </Dropdown.Item>
                                                          ))}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item,'Bedroom', index); // define this function
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>


                                                    <Col sm={2}>

                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>

                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={bedroomFormData[index].remark}
                                                          onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : null
                                  ))}


                              </Col>
                            </Row>
                            <Row>
                              <Col>

                                <Row className="mx-1 my-3">
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemName}
                                        onChange={(e) => setExtraItemName(e.target.value)}
                                        type="text"
                                        placeholder="Item Name"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemMaterialName}
                                        onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                        type="text"
                                        placeholder="Material Name"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemMaterialValue}
                                        onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                        type="number"
                                        placeholder="Material Value"
                                      />
                                    </Form.Group>
                                  </Col>

                                  <Col sm={3}>
                                    <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                      <option>Select Measurement Type</option>
                                      <option value="area">Area</option>
                                      <option value="width">Width, Height & Qty</option>
                                      <option value="rft">RFT</option>
                                      <option value="qty">Quantity</option>
                                      <option value="length">Width & Length</option>
                                      <option value="selection">Selection</option>
                                    </Form.Select>
                                  </Col>

                                  <Col sm={1}>
                                    <Form.Check
                                      inline
                                      label="Wood"
                                      name="Wood"
                                      type="checkbox"
                                      id="inline-checkbox-1"
                                      checked={isChecked}
                                      onChange={handleCheckboxChange}
                                    />
                                  </Col>
                                  <Col sm={2}>
                                    <Button onClick={addNewBedroomItem}>Add Item</Button>
                                  </Col>
                                </Row>





                              </Col>

                            </Row>
                          </Form.Group>


                        </Form>


                      </Col>
                    </Row>

                    <Row style={{
                      // marginBottom: '50px',
                      marginLeft: '1px',
                      padding: '20px',
                      borderRadius: '15px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                      backgroundColor: '#ffffff', // Light background color


                    }} >
                      <Col style={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                      }}>
                        <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                        <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={calculateTotalPricesBeforeSave} >Save</Button>
                      </Col>
                      <Col className="col-sm-3">

                      </Col>
                      <Col className="col-sm-2"><h4>Total Price</h4></Col>
                      <Col className="col-sm-2">
                        {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                      </Col>
                    </Row>

                  </Row> : roomTypeModal == 'Foyer' ?
                    <Row className="p-2" style={{
                      marginBottom: '50px',

                      padding: '20px',
                      marginLeft: '20px',
                      borderRadius: '15px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                      backgroundColor: '#ffffff', // Light background color

                    }} >


                      <div style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '1rem'
                      }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Foyer -- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                        <Form>
                          <InputGroup>
                            <Form.Control
                              style={{
                                borderRadius: "15px",
                                padding: "12px 15px",
                                border: "1px solid #d1d5db",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                transition: "all 0.3s ease",
                                width: "20vw",
                              }}
                              onChange={(e) => setSearch(e.target.value)}
                              placeholder="Search Labels"
                            />
                          </InputGroup>
                        </Form>
                      </div>


                      <Row style={{
                        backgroundColor: "#F2F2F2",
                        height: 'auto',
                        marginLeft: '5px',
                        overflowY: 'auto',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                        borderRadius: '15px',
                        padding: '0 0 0 10px',
                      }}>
                        <Col style={{ minHeight: 380, maxHeight: 480 }}>

                          <Form>

                            <Form.Group>
                              <Row>

                                <Col sm={12}>

                                  {foyerThingsDataCopy
                                    .map((item, index) => ({ item, formData: foyerFormData[index], index }))
                                    .filter(({ item }) => {
                                      const searchQuery = search.toLowerCase();
                                      return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                    })
                                    .map(({ item, formData, index }) => (
                                      item.measurement == "area" ?
                                        <Row className="mx-1 my-3">
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Label
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: "500",
                                                }}
                                              > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                              </Form.Label>
                                            </Form.Group>
                                          </Col>
                                          {/* <Col sm={2}>
                                          <Form.Group>
                                            <Form.Select
                                              value={foyerFormData[index].value}
                                              onChange={(e) => handleFoyerOptionChange(e, index)}


                                            >
                                              <option value="0">None</option>
                                              {item.material.map((item2, index2) => (
                                                <option
                                                  key={index2}
                                                  value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                >
                                                  {item2.label}
                                                </option>
                                              ))}

                                            </Form.Select>
                                          </Form.Group>
                                        </Col> */}
                                          {/* add label option */}
                                          <Col sm={2} style={{ display: 'flex' }}>
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                variant="outline-secondary"
                                                style={{
                                                  width: '12vw',
                                                  backgroundColor: 'white',
                                                  color: 'black',
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                  wordBreak: 'break-word',     // Breaks long words
                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                }}>
                                                {formData.label || 'None'}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                  None
                                                </Dropdown.Item>
                                                {item.material.map((item2, index2) => (
                                                  <Dropdown.Item
                                                    key={index2}
                                                    onClick={() =>
                                                      handleFoyerOptionChange(
                                                        {
                                                          target: {
                                                            value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                            label: item2.label
                                                          }
                                                        },
                                                        index
                                                      )
                                                    }
                                                  >
                                                    {item2.label}
                                                  </Dropdown.Item>
                                                ))}

                                                <Dropdown.Divider />

                                                <div className="px-3 py-2">
                                                  <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                      e.stopPropagation(); // prevent dropdown from closing
                                                      handleAddNewItem(item,'Foyer', index);
                                                    }}
                                                  >
                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                  </Button>
                                                </div>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={foyerFormData[index].area}
                                                onChange={(e) => handleFoyerChange(e, index, "area")}
                                                placeholder="Area"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>

                                          </Col>

                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={foyerFormData[index].price}
                                                // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                placeholder="Price"
                                                disabled={foyerFormData[index].value ? false : true}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                value={foyerFormData[index].remark}
                                                onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                as="textarea" rows={1}
                                                placeholder="Remark"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={1}>
                                            {item.isUserAdded && (
                                              <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                <i class="bi bi-x-circle-fill"></i>
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                        : item.measurement == "width" ?
                                          <Row className="mx-1 my-3">
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={foyerFormData[index].value}
                                                onChange={(e) => handleFoyerOptionChange(e, index)}


                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => (
                                                    <Dropdown.Item
                                                      key={index2}
                                                      onClick={() =>
                                                        handleFoyerOptionChange(
                                                          {
                                                            target: {
                                                              value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                              label: item2.label
                                                            }
                                                          },
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {item2.label}
                                                    </Dropdown.Item>
                                                  ))}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item,'Foyer', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].width}
                                                  onChange={(e) => handleFoyerChange(e, index, "width")}
                                                  placeholder="Width"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].height}
                                                  onChange={(e) => handleFoyerChange(e, index, "height")}
                                                  placeholder="Height"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].qnty}
                                                  onChange={(e) => handleFoyerChange(e, index, "qnty")}
                                                  placeholder="Qty"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].price}
                                                  // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                  placeholder="Price"
                                                  disabled={foyerFormData[index].value ? false : true}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={foyerFormData[index].remark}
                                                  onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                          : item.measurement == "qty" ?
                                            <Row className="mx-1 my-3">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={foyerFormData[index].value}
                                                  onChange={(e) => handleFoyerOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => (
                                                      <Dropdown.Item
                                                        key={index2}
                                                        onClick={() =>
                                                          handleFoyerOptionChange(
                                                            {
                                                              target: {
                                                                value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                label: item2.label
                                                              }
                                                            },
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {item2.label}
                                                      </Dropdown.Item>
                                                    ))}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item,'Foyer', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={foyerFormData[index].qnty}
                                                    onChange={(e) => handleFoyerChange(e, index, "qnty")}
                                                    placeholder="Qty"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={foyerFormData[index].price}
                                                    // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={foyerFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={foyerFormData[index].remark}
                                                    onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row>
                                            : item.measurement == "length" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={foyerFormData[index].value}
                                                    onChange={(e) => handleFoyerOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => (
                                                        <Dropdown.Item
                                                          key={index2}
                                                          onClick={() =>
                                                            handleFoyerOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                  label: item2.label
                                                                }
                                                              },
                                                              index
                                                            )
                                                          }
                                                        >
                                                          {item2.label}
                                                        </Dropdown.Item>
                                                      ))}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item,'Foyer', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={foyerFormData[index].height}
                                                      onChange={(e) => handleFoyerChange(e, index, "height")}
                                                      placeholder="Length"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={foyerFormData[index].width}
                                                      onChange={(e) => handleFoyerChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>


                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={foyerFormData[index].price}
                                                      // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={foyerFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={foyerFormData[index].remark}
                                                      onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row> : item.measurement == "rft" ?
                                                <Row className="mx-1 my-3">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={foyerFormData[index].value}
                                                      onChange={(e) => handleFoyerOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => (
                                                          <Dropdown.Item
                                                            key={index2}
                                                            onClick={() =>
                                                              handleFoyerOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                    label: item2.label
                                                                  }
                                                                },
                                                                index
                                                              )
                                                            }
                                                          >
                                                            {item2.label}
                                                          </Dropdown.Item>
                                                        ))}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item,'Foyer', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={foyerFormData[index].rft}
                                                        onChange={(e) => handleFoyerChange(e, index, "rft")}
                                                        placeholder="RFT"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={foyerFormData[index].price}
                                                        // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={foyerFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={foyerFormData[index].remark}
                                                        onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    {item.isUserAdded && (
                                                      <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                        <i class="bi bi-x-circle-fill"></i>
                                                      </Button>
                                                    )}
                                                  </Col>
                                                </Row> : item.measurement == "selection" ?
                                                  <Row className="mx-1 my-3">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>


                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => (
                                                            <Dropdown.Item
                                                              key={index2}
                                                              onClick={() =>
                                                                handleFoyerOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                      label: item2.label
                                                                    }
                                                                  },
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {item2.label}
                                                            </Dropdown.Item>
                                                          ))}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item,'Foyer', index); // define this function
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>


                                                    <Col sm={2}>

                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>

                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={foyerFormData[index].remark}
                                                          onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : null
                                    ))}


                                </Col>
                              </Row>
                              <Row>
                                <Col>

                                  <Row className="mx-1 my-3">
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemName}
                                          onChange={(e) => setExtraItemName(e.target.value)}
                                          type="text"
                                          placeholder="Item Name"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemMaterialName}
                                          onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                          type="text"
                                          placeholder="Material Name"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemMaterialValue}
                                          onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                          type="number"
                                          placeholder="Material Value"
                                        />
                                      </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                      <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                        <option>Select Measurement Type</option>
                                        <option value="area">Area</option>
                                        <option value="width">Width &  Height</option>
                                        <option value="rft">RFT</option>
                                        <option value="qty">Quantity</option>
                                        <option value="length">Width & Length</option>
                                        <option value="selection">Selection</option>
                                      </Form.Select>
                                    </Col>
                                    <Col sm={1}>
                                      <Form.Check
                                        inline
                                        label="Wood"
                                        name="Wood"
                                        type="checkbox"
                                        id="inline-checkbox-1"
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                      />
                                    </Col>
                                    <Col sm={2}>
                                      <Button onClick={addNewFoyerItem}>Add Item</Button>
                                    </Col>
                                  </Row>





                                </Col>

                              </Row>
                            </Form.Group>


                          </Form>
                        </Col>
                      </Row>

                      <Row style={{
                        // marginBottom: '50px',
                        marginLeft: '1px',
                        padding: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color


                      }} >
                        <Col style={{
                          display: 'flex',
                          justifyContent: 'space-evenly',
                        }}>
                          <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                          <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveFoyerData()}  >Save</Button>
                        </Col>
                        <Col className="col-sm-3">

                        </Col>
                        <Col className="col-sm-2"><h4>Total Price</h4></Col>
                        <Col className="col-sm-2">
                          {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                        </Col>
                      </Row>


                    </Row> : roomTypeModal == 'Living Room' ?
                      <Row className="p-2" style={{
                        marginBottom: '50px',

                        padding: '20px',
                        marginLeft: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color

                      }}>

                        <div style={{
                          display: "flex",
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '1rem'
                        }}>
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>living -- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                          <Form>
                            <InputGroup>
                              <Form.Control
                                style={{
                                  borderRadius: "15px",
                                  padding: "12px 15px",
                                  border: "1px solid #d1d5db",
                                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                  background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                  transition: "all 0.3s ease",
                                  width: "20vw",
                                }}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search Labels"
                              />
                            </InputGroup>
                          </Form>
                        </div>

                        <Row style={{
                          backgroundColor: "#F2F2F2",
                          height: 'auto',
                          marginLeft: '5px',
                          overflowY: 'auto',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                          borderRadius: '15px',
                          padding: '0 0 0 10px',
                        }}>
                          <Col style={{ minHeight: 380, maxHeight: 480 }}>

                            <Form>

                              <Form.Group>
                                <Row>

                                  <Col sm={12}>

                                    {livingThingsDataCopy
                                      .map((item, index) => ({ item, formData: livingFormData[index], index }))
                                      .filter(({ item }) => {
                                        const searchQuery = search.toLowerCase();
                                        return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                      })
                                      .map(({ item, formData, index }) => (
                                        item.measurement == "area" ?
                                          <Row className="mx-1 my-3">
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={livingFormData[index].value}
                                                onChange={(e) => handleLivingOptionChange(e, index)}
                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => (
                                                    <Dropdown.Item
                                                      key={index2}
                                                      onClick={() =>
                                                        handleLivingOptionChange(
                                                          {
                                                            target: {
                                                              value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                              label: item2.label
                                                            }
                                                          },
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {item2.label}
                                                    </Dropdown.Item>
                                                  ))}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item,'LivingRoom', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={livingFormData[index].area}
                                                  onChange={(e) => handleLivingChange(e, index, "area")}
                                                  placeholder="Area"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>

                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={livingFormData[index].price}
                                                  // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                  placeholder="Price"
                                                  disabled={livingFormData[index].value ? false : true}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={livingFormData[index].remark}
                                                  onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                          : item.measurement == "width" ?
                                            <Row className="mx-1 my-3">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={livingFormData[index].value}
                                                  onChange={(e) => handleLivingOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => (
                                                      <Dropdown.Item
                                                        key={index2}
                                                        onClick={() =>
                                                          handleLivingOptionChange(
                                                            {
                                                              target: {
                                                                value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                label: item2.label
                                                              }
                                                            },
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {item2.label}
                                                      </Dropdown.Item>
                                                    ))}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item,'LivingRoom', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].width}
                                                    onChange={(e) => handleLivingChange(e, index, "width")}
                                                    placeholder="Width"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].height}
                                                    onChange={(e) => handleLivingChange(e, index, "height")}
                                                    placeholder="Height"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].qnty}
                                                    onChange={(e) => handleLivingChange(e, index, "qnty")}
                                                    placeholder="Qty"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].price}
                                                    // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={livingFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={livingFormData[index].remark}
                                                    onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row>
                                            : item.measurement == "qty" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={livingFormData[index].value}
                                                    onChange={(e) => handleLivingOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => (
                                                        <Dropdown.Item
                                                          key={index2}
                                                          onClick={() =>
                                                            handleLivingOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                  label: item2.label
                                                                }
                                                              },
                                                              index
                                                            )
                                                          }
                                                        >
                                                          {item2.label}
                                                        </Dropdown.Item>
                                                      ))}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item,'LivingRoom', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={livingFormData[index].qnty}
                                                      onChange={(e) => handleLivingChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={livingFormData[index].price}
                                                      // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={livingFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={livingFormData[index].remark}
                                                      onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row>
                                              : item.measurement == "length" ?
                                                <Row className="mx-1 my-3">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={livingFormData[index].value}
                                                      onChange={(e) => handleLivingOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => (
                                                          <Dropdown.Item
                                                            key={index2}
                                                            onClick={() =>
                                                              handleLivingOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                    label: item2.label
                                                                  }
                                                                },
                                                                index
                                                              )
                                                            }
                                                          >
                                                            {item2.label}
                                                          </Dropdown.Item>
                                                        ))}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item,'LivingRoom', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={livingFormData[index].height}
                                                        onChange={(e) => handleLivingChange(e, index, "height")}
                                                        placeholder="Length"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={livingFormData[index].width}
                                                        onChange={(e) => handleLivingChange(e, index, "width")}
                                                        placeholder="Width"
                                                      />
                                                    </Form.Group>
                                                  </Col>


                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={livingFormData[index].price}
                                                        // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={livingFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={livingFormData[index].remark}
                                                        onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                </Row> : item.measurement == "rft" ?
                                                  <Row className="mx-1 my-3">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={livingFormData[index].value}
                                                        onChange={(e) => handleLivingOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                          <option
                                                            key={index2}
                                                            value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                          >
                                                            {item2.label}
                                                          </option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col> */}
                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => (
                                                            <Dropdown.Item
                                                              key={index2}
                                                              onClick={() =>
                                                                handleLivingOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                      label: item2.label
                                                                    }
                                                                  },
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {item2.label}
                                                            </Dropdown.Item>
                                                          ))}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item,'LivingRoom', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={livingFormData[index].rft}
                                                          onChange={(e) => handleLivingChange(e, index, "rft")}
                                                          placeholder="RFT"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={livingFormData[index].price}
                                                          // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={livingFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={livingFormData[index].remark}
                                                          onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : item.measurement == "selection" ?
                                                    <Row className="mx-1 my-3">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          >
                                                            <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>


                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => (
                                                              <Dropdown.Item
                                                                key={index2}
                                                                onClick={() =>
                                                                  handleLivingOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                        label: item2.label
                                                                      }
                                                                    },
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                {item2.label}
                                                              </Dropdown.Item>
                                                            ))}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item,'LivingRoom', index); // define this function
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>


                                                      <Col sm={2}>

                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>

                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={livingFormData[index].remark}
                                                            onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        {item.isUserAdded && (
                                                          <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                            <i class="bi bi-x-circle-fill"></i>
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row> : null
                                      ))}


                                  </Col>
                                </Row>
                                <Row>
                                  <Col>

                                    <Row className="mx-1 my-3">
                                      <Col sm={2}>
                                        <Form.Group >
                                          <Form.Control
                                            value={extraItemName}
                                            onChange={(e) => setExtraItemName(e.target.value)}
                                            type="text"
                                            placeholder="Item Name"
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group >
                                          <Form.Control
                                            value={extraItemMaterialName}
                                            onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                            type="text"
                                            placeholder="Material Name"
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group >
                                          <Form.Control
                                            value={extraItemMaterialValue}
                                            onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                            type="number"
                                            placeholder="Material Value"
                                          />
                                        </Form.Group>
                                      </Col>

                                      <Col sm={3}>
                                        <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                          <option>Select Measurement Type</option>
                                          <option value="area">Area</option>
                                          <option value="width">Width &  Height</option>
                                          <option value="rft">RFT</option>
                                          <option value="qty">Quantity</option>
                                          <option value="length">Width & Length</option>
                                          <option value="selection">Selection</option>
                                        </Form.Select>
                                      </Col>
                                      <Col sm={1}>
                                        <Form.Check
                                          inline
                                          label="Wood"
                                          name="Wood"
                                          type="checkbox"
                                          id="inline-checkbox-1"
                                          checked={isChecked}
                                          onChange={handleCheckboxChange}
                                        />
                                      </Col>
                                      <Col sm={2}>
                                        <Button onClick={addNewLivingItem}>Add Item</Button>
                                      </Col>
                                    </Row>





                                  </Col>

                                </Row>
                              </Form.Group>


                            </Form>
                          </Col>
                        </Row>



                        <Row style={{
                          // marginBottom: '50px',
                          marginLeft: '1px',
                          padding: '20px',
                          borderRadius: '15px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                          backgroundColor: '#ffffff', // Light background color


                        }} >
                          <Col style={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                          }}>
                            <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                            <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveLivingData()}  >Save</Button>
                          </Col>
                          <Col className="col-sm-3">

                          </Col>
                          <Col className="col-sm-2"><h4>Total Price</h4></Col>
                          <Col className="col-sm-2">
                            {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                            <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                          </Col>
                        </Row>

                      </Row> : roomTypeModal == 'Other Works' ?
                        <Row className="p-2" style={{
                          marginBottom: '50px',

                          padding: '20px',
                          marginLeft: '20px',
                          borderRadius: '15px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                          backgroundColor: '#ffffff', // Light background color

                        }} >

                          <div style={{
                            display: "flex",
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '1rem'
                          }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Other Works -- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                            <Form>
                              <InputGroup>
                                <Form.Control
                                  style={{
                                    borderRadius: "15px",
                                    padding: "12px 15px",
                                    border: "1px solid #d1d5db",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                    transition: "all 0.3s ease",
                                    width: "20vw",
                                  }}
                                  onChange={(e) => setSearch(e.target.value)}
                                  placeholder="Search Labels"
                                />
                              </InputGroup>
                            </Form>
                          </div>


                          <Row style={{
                            backgroundColor: "#F2F2F2",
                            height: 'auto',
                            marginLeft: '5px',
                            overflowY: 'auto',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                            borderRadius: '15px',
                            padding: '0 0 0 10px',
                          }}>
                            <Col style={{ minHeight: 380, maxHeight: 480 }}>

                              <Form>

                                <Form.Group>
                                  <Row>

                                    <Col sm={12}>

                                      {otherThings
                                        .map((item, index) => ({ item, formData: otherFormData[index], index }))
                                        .filter(({ item }) => {
                                          const searchQuery = search.toLowerCase();
                                          return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                        })
                                        .map(({ item, formData, index }) => (
                                          item.measurement == "area" ?
                                            <Row className="mx-1 my-3">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={otherFormData[index].value}
                                                  onChange={(e) => handleOtherOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => (
                                                      <Dropdown.Item
                                                        key={index2}
                                                        onClick={() =>
                                                          handleOtherOptionChange(
                                                            {
                                                              target: {
                                                                value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                label: item2.label
                                                              }
                                                            },
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {item2.label}
                                                      </Dropdown.Item>
                                                    ))}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item,'OtherWorks', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={otherFormData[index].area}
                                                    onChange={(e) => handleOtherChange(e, index, "area")}
                                                    placeholder="Area"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={otherFormData[index].price}
                                                    // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={otherFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={3}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={otherFormData[index].remark}
                                                    onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                            : item.measurement == "width" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={otherFormData[index].value}
                                                    onChange={(e) => handleOtherOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => (
                                                        <Dropdown.Item
                                                          key={index2}
                                                          onClick={() =>
                                                            handleOtherOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                  label: item2.label
                                                                }
                                                              },
                                                              index
                                                            )
                                                          }
                                                        >
                                                          {item2.label}
                                                        </Dropdown.Item>
                                                      ))}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item,'OtherWorks', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].width}
                                                      onChange={(e) => handleOtherChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].height}
                                                      onChange={(e) => handleOtherChange(e, index, "height")}
                                                      placeholder="Height"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].qnty}
                                                      onChange={(e) => handleOtherChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].price}
                                                      // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={otherFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={3}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={otherFormData[index].remark}
                                                      onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                              : item.measurement == "qty" ?
                                                <Row className="mx-1 my-3">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={otherFormData[index].value}
                                                      onChange={(e) => handleOtherOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => (
                                                          <Dropdown.Item
                                                            key={index2}
                                                            onClick={() =>
                                                              handleOtherOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                    label: item2.label
                                                                  }
                                                                },
                                                                index
                                                              )
                                                            }
                                                          >
                                                            {item2.label}
                                                          </Dropdown.Item>
                                                        ))}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item,'OtherWorks', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={otherFormData[index].qnty}
                                                        onChange={(e) => handleOtherChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={otherFormData[index].price}
                                                        // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={otherFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={3}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={otherFormData[index].remark}
                                                        onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row>
                                                : item.measurement == "length" ?
                                                  <Row className="mx-1 my-3">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={otherFormData[index].value}
                                                        onChange={(e) => handleOtherOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                          <option
                                                            key={index2}
                                                            value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                          >
                                                            {item2.label}
                                                          </option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col> */}
                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => (
                                                            <Dropdown.Item
                                                              key={index2}
                                                              onClick={() =>
                                                                handleOtherOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                      label: item2.label
                                                                    }
                                                                  },
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {item2.label}
                                                            </Dropdown.Item>
                                                          ))}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item,'OtherWorks', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={otherFormData[index].height}
                                                          onChange={(e) => handleOtherChange(e, index, "height")}
                                                          placeholder="Length"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={otherFormData[index].width}
                                                          onChange={(e) => handleOtherChange(e, index, "width")}
                                                          placeholder="Width"
                                                        />
                                                      </Form.Group>
                                                    </Col>


                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={otherFormData[index].price}
                                                          // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={otherFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={otherFormData[index].remark}
                                                          onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                  </Row> : item.measurement == "rft" ?
                                                    <Row className="mx-1 my-3">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Select
                                                          value={otherFormData[index].value}
                                                          onChange={(e) => handleOtherOptionChange(e, index)}


                                                        >
                                                          <option value="0">None</option>
                                                          {item.material.map((item2, index2) => (
                                                            <option
                                                              key={index2}
                                                              value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                            >
                                                              {item2.label}
                                                            </option>
                                                          ))}

                                                        </Form.Select>
                                                      </Form.Group>
                                                    </Col> */}
                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => (
                                                              <Dropdown.Item
                                                                key={index2}
                                                                onClick={() =>
                                                                  handleOtherOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                        label: item2.label
                                                                      }
                                                                    },
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                {item2.label}
                                                              </Dropdown.Item>
                                                            ))}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item,'OtherWorks', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={otherFormData[index].rft}
                                                            onChange={(e) => handleOtherChange(e, index, "rft")}
                                                            placeholder="RFT"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={otherFormData[index].price}
                                                            // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={otherFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={3}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={otherFormData[index].remark}
                                                            onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                    </Row> : item.measurement == "painting" ?
                                                      <Row className="mx-1 my-3">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Select
                                                            value={otherFormData[index].value}
                                                            onChange={(e) => handleOtherOptionChange(e, index)}


                                                          >
                                                            <option value="0">None</option>
                                                            {item.material.map((item2, index2) => (
                                                              <option
                                                                key={index2}
                                                                value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                              >
                                                                {item2.label}
                                                              </option>
                                                            ))}

                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col> */}
                                                        {/* add label option */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => (
                                                                <Dropdown.Item
                                                                  key={index2}
                                                                  onClick={() =>
                                                                    handleOtherOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                          label: item2.label
                                                                        }
                                                                      },
                                                                      index
                                                                    )
                                                                  }
                                                                >
                                                                  {item2.label}
                                                                </Dropdown.Item>
                                                              ))}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item,'OtherWorks', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={otherFormData[index].painting}
                                                              onChange={(e) => handleOtherChange(e, index, "painting")}
                                                              placeholder="Area"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={otherFormData[index].price}
                                                              // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={otherFormData[index].value ? false : true}
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={otherFormData[index].remark}
                                                              onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                      </Row> : null
                                        ))}


                                    </Col>
                                  </Row>

                                </Form.Group>


                              </Form>
                            </Col>
                          </Row>

                          <Row style={{
                            // marginBottom: '50px',
                            marginLeft: '1px',
                            padding: '20px',
                            borderRadius: '15px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                            backgroundColor: '#ffffff', // Light background color


                          }} >
                            <Col style={{
                              display: 'flex',
                              justifyContent: 'space-evenly',
                            }}>
                              <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                              <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveOtherData()}  >Save</Button>
                            </Col>
                            <Col className="col-sm-3">

                            </Col>
                            <Col className="col-sm-2"><h4>Total Price</h4></Col>
                            <Col className="col-sm-2">
                              {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                            </Col>
                          </Row>

                        </Row> : roomTypeModal == 'Loose Furniture' ?
                          <Row className="p-2" style={{
                            marginBottom: '50px',

                            padding: '20px',
                            marginLeft: '20px',
                            borderRadius: '15px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                            backgroundColor: '#ffffff', // Light background color

                          }} >

                            <div style={{
                              display: "flex",
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '1rem'
                            }}>
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>loose Furniture-- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>

                              <Form>
                                <InputGroup>
                                  <Form.Control
                                    style={{
                                      borderRadius: "15px",
                                      padding: "12px 15px",
                                      border: "1px solid #d1d5db",
                                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                      background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                      transition: "all 0.3s ease",
                                      width: "20vw",
                                    }}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search Labels"
                                  />
                                </InputGroup>
                              </Form>
                            </div>

                            <Row style={{
                              backgroundColor: "#F2F2F2",
                              height: 'auto',
                              marginLeft: '5px',
                              overflowY: 'auto',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                              borderRadius: '15px',
                              padding: '0 0 0 10px',
                            }}>
                              <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                <Form>

                                  <Form.Group>
                                    <Row>

                                      <Col sm={12}>

                                        {looseThingsData.map((item, index) => (
                                          item.measurement == "area" ?
                                            <Row className="mx-1 my-3">
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                                {/* <Form.Group>
                                                  <Form.Select
                                                    value={looseFormData[index].value}
                                                    onChange={(e) => handleLooseOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                   {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}   

                                                  </Form.Select>
                                                </Form.Group> 
                                              </Col> */}
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={looseFormData[index].area}
                                                    onChange={(e) => handleLooseChange(e, index, "area")}
                                                    placeholder="Area"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={looseFormData[index].price}
                                                    // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={looseFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={3}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={looseFormData[index].remark}
                                                    onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                            : item.measurement == "width" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={looseFormData[index].value}
                                                      onChange={(e) => handleLooseOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].width}
                                                      onChange={(e) => handleLooseChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].height}
                                                      onChange={(e) => handleLooseChange(e, index, "height")}
                                                      placeholder="Height"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].qnty}
                                                      onChange={(e) => handleLooseChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].price}
                                                      // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={looseFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={3}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={looseFormData[index].remark}
                                                      onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                              : item.measurement == "qty" ?
                                                <Row className="mx-1 my-3">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={looseFormData[index].value}
                                                        onChange={(e) => handleLooseOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col> */}
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={looseFormData[index].qnty}
                                                        onChange={(e) => handleLooseChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={looseFormData[index].price}
                                                        // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={looseFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={3}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={looseFormData[index].remark}
                                                        onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row>
                                                : item.measurement == "length" ?
                                                  <Row className="mx-1 my-3">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Select
                                                          value={looseFormData[index].value}
                                                          onChange={(e) => handleLooseOptionChange(e, index)}


                                                        >
                                                          <option value="0">None</option>
                                                          {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                        </Form.Select>
                                                      </Form.Group>
                                                    </Col> */}
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={looseFormData[index].height}
                                                          onChange={(e) => handleLooseChange(e, index, "height")}
                                                          placeholder="Length"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={looseFormData[index].width}
                                                          onChange={(e) => handleLooseChange(e, index, "width")}
                                                          placeholder="Width"
                                                        />
                                                      </Form.Group>
                                                    </Col>


                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={looseFormData[index].price}
                                                          // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={looseFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={looseFormData[index].remark}
                                                          onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                  </Row> : item.measurement == "rft" ?
                                                    <Row className="mx-1 my-3">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Select
                                                            value={looseFormData[index].value}
                                                            onChange={(e) => handleLooseOptionChange(e, index)}


                                                          >
                                                            <option value="0">None</option>
                                                            {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col> */}
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={looseFormData[index].rft}
                                                            onChange={(e) => handleLooseChange(e, index, "rft")}
                                                            placeholder="RFT"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={looseFormData[index].price}
                                                            // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={looseFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={3}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={looseFormData[index].remark}
                                                            onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                    </Row> : null
                                        ))}


                                      </Col>
                                    </Row>

                                  </Form.Group>


                                </Form>
                              </Col>
                            </Row>

                            <Row style={{
                              // marginBottom: '50px',
                              marginLeft: '1px',
                              padding: '20px',
                              borderRadius: '15px',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                              backgroundColor: '#ffffff', // Light background color


                            }} >
                              <Col style={{
                                display: 'flex',
                                justifyContent: 'space-evenly',
                              }}>
                                <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                                <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveLooseData()}  >Save</Button>
                              </Col>
                              <Col className="col-sm-3">

                              </Col>
                              <Col className="col-sm-2"><h4>Total Price</h4></Col>
                              <Col className="col-sm-2">
                                {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                                <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                              </Col>
                            </Row>

                          </Row> : roomTypeModal == 'Accessories' ?
                            <Row className="p-2" style={{
                              marginBottom: '50px',

                              padding: '20px',
                              marginLeft: '20px',
                              borderRadius: '15px',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                              backgroundColor: '#ffffff', // Light background color

                            }}>


                              <div style={{
                                display: "flex",
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '1rem'
                              }}>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5> Accessories-- </h5><h6 style={{ color: '#e85d13' }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6></span>
                                <Form>
                                  <InputGroup>
                                    <Form.Control
                                      style={{
                                        borderRadius: "15px",
                                        padding: "12px 15px",
                                        border: "1px solid #d1d5db",
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                        background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                        transition: "all 0.3s ease",
                                        width: "20vw",
                                      }}
                                      onChange={(e) => setSearch(e.target.value)}
                                      placeholder="Search Labels"
                                    />
                                  </InputGroup>
                                </Form>
                              </div>


                              <Row style={{
                                backgroundColor: "#F2F2F2",
                                height: 'auto',
                                marginLeft: '5px',
                                overflowY: 'auto',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '15px',
                                padding: '0 0 0 10px',
                              }}>
                                <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                  <Form>

                                    <Form.Group>
                                      <Row>

                                        <Col sm={12}>

                                          {accessoriesThingsData.map((item, index) => (
                                            item.measurement == "area" ?
                                              <Row className="mx-1 my-3">
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={accessoriesFormData[index].value}
                                                      onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        priceGen === 'oldvalue' ? (
                                                          <option value={item2.oldvalue} key={index2}>
                                                            {item2.label}
                                                          </option>
                                                        ) : (
                                                          <option value={item2.value} key={index2}>
                                                            {item2.label}
                                                          </option>
                                                        )
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={accessoriesFormData[index].area}
                                                      onChange={(e) => handleAccessoriesChange(e, index, "area")}
                                                      placeholder="Area"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={accessoriesFormData[index].price}
                                                      // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={accessoriesFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={3}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={accessoriesFormData[index].remark}
                                                      onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                              : item.measurement == "width" ?
                                                <Row className="mx-1 my-3">
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={accessoriesFormData[index].value}
                                                        onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                          <option value={item2.value} key={index2}>{item2.label}</option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={accessoriesFormData[index].width}
                                                        onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                        placeholder="Width"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={accessoriesFormData[index].height}
                                                        onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                        placeholder="Height"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={accessoriesFormData[index].qnty}
                                                        onChange={(e) => handleAccessoriesChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={accessoriesFormData[index].price}
                                                        // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={accessoriesFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={3}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={accessoriesFormData[index].remark}
                                                        onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row>
                                                : item.measurement == "qty" ?
                                                  <Row className="mx-1 my-3">
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Select
                                                          value={accessoriesFormData[index].value}
                                                          onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                        >
                                                          <option value="0">None</option>
                                                          {item.material.map((item2, index2) => (
                                                            priceGen === 'oldvalue' ? (
                                                              <option value={item2.oldvalue} key={index2}>
                                                                {item2.label}
                                                              </option>
                                                            ) : (
                                                              <option value={item2.value} key={index2}>
                                                                {item2.label}
                                                              </option>
                                                            )
                                                          ))}

                                                        </Form.Select>
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={accessoriesFormData[index].qnty}
                                                          onChange={(e) => handleAccessoriesChange(e, index, "qnty")}
                                                          placeholder="Qty"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={accessoriesFormData[index].price}
                                                          // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={accessoriesFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={accessoriesFormData[index].remark}
                                                          onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                  </Row>
                                                  : item.measurement == "length" ?
                                                    <Row className="mx-1 my-3">
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Select
                                                            value={accessoriesFormData[index].value}
                                                            onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                          >
                                                            <option value="0">None</option>
                                                            {item.material.map((item2, index2) => (
                                                              priceGen === 'oldvalue' ? (
                                                                <option value={item2.oldvalue} key={index2}>
                                                                  {item2.label}
                                                                </option>
                                                              ) : (
                                                                <option value={item2.value} key={index2}>
                                                                  {item2.label}
                                                                </option>
                                                              )
                                                            ))}

                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].height}
                                                            onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                            placeholder="Length"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].width}
                                                            onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                            placeholder="Width"
                                                          />
                                                        </Form.Group>
                                                      </Col>


                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].price}
                                                            // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={accessoriesFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={3}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={accessoriesFormData[index].remark}
                                                            onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                    </Row> : item.measurement == "rft" ?
                                                      <Row className="mx-1 my-3">
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Select
                                                              value={accessoriesFormData[index].value}
                                                              onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                            >
                                                              <option value="0">None</option>
                                                              {item.material.map((item2, index2) => (
                                                                priceGen === 'oldvalue' ? (
                                                                  <option value={item2.oldvalue} key={index2}>
                                                                    {item2.label}
                                                                  </option>
                                                                ) : (
                                                                  <option value={item2.value} key={index2}>
                                                                    {item2.label}
                                                                  </option>
                                                                )
                                                              ))}

                                                            </Form.Select>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={accessoriesFormData[index].rft}
                                                              onChange={(e) => handleAccessoriesChange(e, index, "rft")}
                                                              placeholder="RFT"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={accessoriesFormData[index].price}
                                                              // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={accessoriesFormData[index].value ? false : true}
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={3}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={accessoriesFormData[index].remark}
                                                              onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                      </Row> : null
                                          ))}


                                        </Col>
                                      </Row>

                                    </Form.Group>


                                  </Form>
                                </Col>
                              </Row>
                              <Row style={{
                                // marginBottom: '50px',
                                marginLeft: '1px',
                                padding: '20px',
                                borderRadius: '15px',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                backgroundColor: '#ffffff', // Light background color


                              }} >
                                <Col style={{
                                  display: 'flex',
                                  justifyContent: 'space-evenly',
                                }}>
                                  <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                                  <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveAccessoriesData()}  >Save</Button>
                                </Col>
                                <Col className="col-sm-3">

                                </Col>
                                <Col className="col-sm-2"><h4>Total Price</h4></Col>
                                <Col className="col-sm-2">
                                  {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                                </Col>
                              </Row>

                            </Row> : roomTypeModal == 'ExtraItems' ?
                              <Row className="p-2"
                                style={{
                                  marginBottom: '50px',
                                  marginLeft: '20px',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                  backgroundColor: '#ffffff', // Light background color

                                }}>
                                {!priceGen ? (
                                  <h4>Extra items -- New Value</h4>
                                ) : (
                                  <h4>Extra items -- {priceGen === 'value' ? 'New Value' : 'Old Value'}</h4>
                                )}



                                <Row style={{
                                  marginBottom: '50px',
                                  marginLeft: '1px',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                  backgroundColor: '#ffffff', // Light background color

                                }}>
                                  <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                    {materialFields.map((field, index) => (
                                      <Row key={index} className="mx-1 my-1">
                                        <Col sm={2}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Label style={{
                                            fontSize: 16,
                                            fontWeight: "500",
                                          }}>Extra items</Form.Label>
                                        </Form.Group></Col>
                                        <Col sm={3}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Control
                                            type="text"
                                            value={field.label}
                                            onChange={(e) => handleFieldChange(e.target.value, index, 'label')}
                                            placeholder="Item Name"
                                            required={false}
                                          />
                                        </Form.Group></Col>
                                        <Col sm={3}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Control
                                            type="number"
                                            value={field.value}
                                            onChange={(e) => handleFieldChange(e.target.value, index, 'value')}
                                            placeholder="Item Price"
                                            required={false}
                                          />
                                        </Form.Group>
                                        </Col>
                                        <Col sm={3}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Control
                                            as="textarea" rows={1}
                                            value={field.remark}
                                            onChange={(e) => handleFieldChange(e.target.value, index, 'remark')}
                                            placeholder="Remark"
                                            required={false}
                                          />

                                        </Form.Group>
                                        </Col>
                                        <Col sm={1}> <Button variant="danger" onClick={() => handleRemoveField(index)} >
                                          <i class="bi bi-x-circle-fill"></i>
                                        </Button></Col>
                                        <Col>

                                        </Col>
                                      </Row>
                                    ))}
                                    <Col><Button variant="success" onClick={handleAddField} > Add options <i class="bi bi-plus-circle-fill"></i> </Button></Col>

                                  </Col>
                                </Row>


                                <Row style={{
                                  // marginBottom: '50px',
                                  marginLeft: '1px',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                  backgroundColor: '#ffffff', // Light background color


                                }} >
                                  <Col style={{
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                  }}>
                                    <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => setRoomTypeModal("")} >Go Back</Button>
                                    <Button className="buttonDesign" style={{ fontSize: 13, width: '10vw', fontSize: "bold" }} onClick={() => saveExtraItemsData()}  >Save</Button>
                                  </Col>
                                  <Col className="col-sm-3">

                                  </Col>
                                  <Col className="col-sm-2"><h4>Total Price</h4></Col>
                                  <Col className="col-sm-2">
                                    {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{totalValues()}</h4></span>
                                  </Col>
                                </Row>

                              </Row> : null}




            {/* Bedroom modal */}

          </Row>

        </Col>
      </Row>

    </Container>
  );
}
